(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Home-hero-section"] && !Shopify.designMode) return;
  try {
    
  (function($){
     $(document).ready(function () {
    $(document).on( "click","a.submitbannerfrom" , function() {
   //   alert('sdsdfsd');
      //console.log('bannerbuttonlick');
    $( ".hellovs" ).trigger( "click" );
  });
   });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-orders"]) return;
  try {
    
  // reorder funtioanlity
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.reorder-btn').forEach((button) => {
      button.addEventListener('click', function () {
        $(this).addClass('add_loader');
        refreshLineItems = this.dataset.lineItems.replace(',]', ']');
        //console.log("this.dataset.lineItems",refreshLineItems);
        let items = JSON.parse(refreshLineItems);
        let cartItems = items.map((item) => {
          //console.log(item.selling_plan);
          if (item.selling_plan != '') {
            return {
              id: Number(item.variant_id),
              quantity: Number(item.quantity),
              selling_plan: Number(item.selling_plan),
              properties: item.properties || {},
            };
          } else {
            return {
              id: Number(item.variant_id),
              quantity: Number(item.quantity),
              properties: item.properties || {},
            };
          }
        });

        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: cartItems }),
            });
          })
          .then(() => {
            window.location.href = '/cart';
          })
          .catch((err) => console.error('Reorder failed:', err));
      });
    });
  });

  // tootip on mobile
  if ($(window).width() <= 750) {
    $(document).ready(function () {
      $('.tooltip').click(function (e) {
        e.stopPropagation();
        $(this).find('.tooltip-pop').toggle();

        $('.tooltip').not(this).find('.tooltip-pop').hide();
      });
      $(document).click(function () {
        $('.tooltip-pop').hide();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-program-2"] && !Shopify.designMode) return;
  try {
    
(function($){ 
//console.log('affiliatepage');
$(document).ready(function(){
$(document).on("click", ".simpleAccordian .simpleAccordian__toggle", (function () {
        $(this).parent().siblings().removeClass("active"),
        $(this).parent().siblings().find(".simpleAccordian__cntnt").slideUp(),
        $(this).parent().toggleClass("active"),
        $(this).next(".simpleAccordian__cntnt").slideToggle(200)
        })
    );
});
})(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anniversary_header"]) return;
  try {
    
(function($){ 
$(document).ready(function(){
 let scrollheight
            if(window.matchMedia('(max-width: 750px)').matches) {
                scrollheight = 120
            }else{
                scrollheight = 100
                
            }
            
            let navhldr = $('.headerSection');
            let windowtop = scrollheight;
          
            
            // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
            function navbarCheck() {
                if ($(window).scrollTop() >= windowtop) {
                      let navhldrHeight = navhldr.innerHeight()
                    navhldr.addClass('sticky');
                    $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                    $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                } else {
                    navhldr.removeClass('sticky');
                    $(".headerFixed__wrap").css("height" ,"auto")
                    $(".recommendedFilter__Row").css("top" ,"auto")
                }
            }
            
            // navbarCheck()
            $(window).scroll(function () {
                navbarCheck()
            });  

            // navbarCheck()
            $(window).ready(function () {
                navbarCheck()
                //console.log("Hello World!");
            });   
            
            

            var new_scroll_position = 0;
            var last_scroll_position;
            var header = document.getElementById("header");

            window.addEventListener('scroll', function(e) {
                last_scroll_position = window.scrollY;

                if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                    header.classList.remove("slideDown");
                    header.classList.add("slideUp");
                    $("body").addClass("slideDownBody");
                    

                // Scrolling up
                } else if (new_scroll_position > last_scroll_position) {
                    header.classList.remove("slideUp");
                    header.classList.add("slideDown");
                    $("body").removeClass("slideDownBody");
                }

                new_scroll_position = last_scroll_position;
            });

  });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anti-cellulite-grid"] && !Shopify.designMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
//console.log('acai');
var cip = $(".beauty__routine__video").hover( hoverVideo, hideVideo );

function hoverVideo(e) {  
    $('video', this).get(0).play(); 
}

function hideVideo(e) {
    $('video', this).get(0).pause(); 
}
  });


      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barbieFeaturedImages"] && !Shopify.designMode) return;
  try {
    
(function($){ 
  function run_animate() {
        var animation_items = $(".animate");

        var ml3 = 0;
        setInterval(function() {
            if (ml3 <= 0 - $(".barbie__animate .barbie__animateWrap").width() / 2) {
            ml3 = 0;
            }
        $(".barbie__animate .barbie__animateWrap").css("margin-left", ml3);
            ml3 -= 1;
        }, 10);
        }
     run_animate();   
       
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-gift-of-year"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){ 
  console.log("vihps");
  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
        $(".sticky-wrap").addClass('sticky-show')
    } else {
        $(".sticky-wrap").removeClass('sticky-show')
    }
});

  // Smooth scroll when clicking on links with class 'cm_content_entry p a'
  $(document).on('click', '.cm_content_entry p a', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      // Calculate offset from the top of the section
      var offset = $(hash).offset().top;

      // Smoothly scroll to the section
      $('html, body').animate({
        scrollTop: offset
      }, 800); // Adjust the duration as needed (in milliseconds)
    }
  });



  });
  })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bogo"] && !Shopify.designMode) return;
  try {
    
 (function($){
      $(document).ready(function () {
             //console.log('bogopage');
var vipDealSlider = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    dots: false,
     infinite: false,
    responsive: [
        // { breakpoint: 1100, settings: { slidesToShow: 3 } },
        { breakpoint: 751, settings: { slidesToShow: 2 } },
        { breakpoint: 340, settings: { slidesToShow: 1 } },
        ],
    }

  $(".deal-Slider").slick(vipDealSlider);
        
          var vipMainSlider = {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
              adaptiveHeight: true,
              dots: false,
               infinite: false,
              responsive: [
                  { breakpoint: 1100, settings: { slidesToShow: 3 } },
                  { breakpoint: 751, settings: { slidesToShow: 2 } },
                  { breakpoint: 500, settings: { slidesToShow: 2 } },
                  ],
              }

              $(".InnerTabSlider").slick(vipMainSlider);
              $(document).ready(function () {
                  $('.unslickTabSlider li').click(function () {
                      var tab_id = $(this).attr('data-tab');
                      //alert(tab_id);
                      $("#" + tab_id).find('.InnerTabSlider').slick("unslick");
                      $("#" + tab_id).find('.InnerTabSlider').slick(vipMainSlider);
                  });
              });


              $(document).on("click", ".banner-accordian__toggle", (function () {
                  $(this).parent().siblings().removeClass("active"),
                      $(this).parent().siblings().find(".banner-accordian__cntnt").slideUp(1000),
                      $(this).parent().toggleClass("active"),
                      $(this).next(".banner-accordian__cntnt").slideToggle(500)

                      $(this).parent().find(".InnerTabSlider, .deal-Slider").slick("unslick");
                      $(this).parent().find(".InnerTabSlider").slick(vipMainSlider);
                      $(this).parent().find(".deal-Slider").slick(vipDealSlider);
              })
              );

       });
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tab"] && !Shopify.designMode) return;
  try {
    
  
(function($){   
$(document).ready(function(){
 
  if(view_all == true ) {
    var infinite1 = false;
  } else
  {
   var infinite1 = true;
  }
  //console.log(view_all); 
//console.log(infinite1); 
 
 
var vipMainSlider = {
slidesToShow: slidesToShow,
slidesToScroll: 4,
arrows: arrows,
dots: dots,
adaptiveHeight: true,
infinite: infinite1,
responsive: [
{ breakpoint: 990, settings: { slidesToShow: slidesToShowtab, slidesToScroll:2 } },  
{ breakpoint: 751, settings: { slidesToShow: slidesToShowmob, slidesToScroll:2} },
],
   }
  //console.log(vipMainSlider);
   $(".InnerTabSlider").slick(vipMainSlider);
   
              $(document).ready(function () {
                  $('.unslickTabSlider li').click(function () {
                        var tab_id = $(this).attr('data-tab');
                       var tab_name = $(this).find('.giftSetTab__cntnt').text();  
                       $(".tab-title").text('Shop '+ tab_name);
                      $("#" + tab_id).find('.InnerTabSlider').slick("unslick");
                      $("#" + tab_id).find('.InnerTabSlider').slick(vipMainSlider);
                  });
              });




  
    });
})(jQuery);   


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-top-area"] && !Shopify.designMode) return;
  try {
    
 (function($){
     $(document).ready(function(){
      const smallUsps = Array.from(document.querySelectorAll('.all-usp-sm .single-usp'));
        let showElmIndex = 0;
        //console.log(smallUsps);
        setInterval(() => {
            smallUsps.map((item, index) => {
                if (index === showElmIndex) {
                    item.style.display = 'flex';
                } else {
                    item.style.display = 'none';
                }
            })
            showElmIndex === smallUsps.length - 1 ? showElmIndex = 0 : showElmIndex++;
        }, 2500)
        });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactForm"] && !Shopify.designMode) return;
  try {
    
 (function($){
      $(document).ready(function () {
      //console.log('contact');
        $('.tooltipToggle').click(function () {
          $(this).addClass('active-tooltip');
          $(this).parents('.tooltipOuter').find('.tooltip-Info').toggle();
        });
        $('#contacttopics').on('change', function() {
          var optionchossed = this.value.toLowerCase().replace(/\s/g, '_');
             if(optionchossed!='' && optionchossed != 'influencer'){
            //console.log(optionchossed);
            $('.step-tooltip').addClass('hide');
            $('.'+optionchossed).removeClass('hide');
            $('.contactmessage').removeClass('hide');
            $('.order_number').removeClass('hide');
            $('#submitticket').removeClass('hide');
         }else if(optionchossed === 'influencer'){
           window.location.href = "https://www.trulybeauty.com/pages/influencer";
            $('.order_status').addClass('hide');
            $('.order_number').addClass('hide');
            $('.contactmessage').addClass('hide');
            $('#submitticket').addClass('hide');
          }else{
            $('.order_status').addClass('hide');

            $('.order_number').addClass('hide');
            $('.contactmessage').addClass('hide');
            $('#submitticket').addClass('hide');
          }
        });
        if(document.getElementById("customeremail").value.length != 0){
          var customeremail = $("#customeremail").val();
          if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($("#customeremail").val())) {
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/gorgias/getcustomer.php",
              type: 'POST',
              data: {"customeremail":customeremail},
              async: true,
              success: function (data) {
                $('.order_number_field').html(data);

              },
              timeout: 5000000, // sets timeout to 5 seconds
              // contentType: false,
              //  processData: false
            });

          }
        }
        $("#customeremail").blur(function(){
          var customeremail = $("#customeremail").val();
          if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($("#customeremail").val())) {
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/gorgias/getcustomer.php",
              type: 'POST',
              data: {"customeremail":customeremail},
              async: true,
              success: function (data) {
                $('.order_number_field').html(data);

              },
              timeout: 5000000, // sets timeout to 5 seconds
              // contentType: false,
              //  processData: false
            });

          }

        });
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#contactUs-Form").submit(function(){
          required = ["contactcomment"];
          srequired = ["contacttopics"];
          email = $("#customeremail");
          for (i=0;i<required.length;i++) {
            var textarea = $('#'+required[i]);
            if ((textarea.val() == "") || (textarea.val() == emptyerror)) {
              textarea.addClass("needsfilled");
              textarea.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              textarea.removeClass("needsfilled");
            }
          }
          for (i=0;i<srequired.length;i++) {
            var selectinput = $('#'+srequired[i]);
            if (selectinput.val() == "") {
              selectinput.addClass("needsfilled");
            } else {
              selectinput.removeClass("needsfilled");
            }
          }
          //var newpassword = $('#password').val();
          //var conformpassword = $('#confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}


          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if ($("#other_guidelines").hasClass("needsfilled")) {
            return false;
          }else if ($("#contacttopics").hasClass("needsfilled")) {
            return false;
          } else {

            var $form = $('#contactUs-Form');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#submitticket').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#submitticket').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/gorgias/creategticket.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#submitticket').prop('disabled', false);
                $('#contactUs-Form')[0].reset();
                if (data.indexOf('Request Submitted Sucessfully.') > -1) {
                  $('.contact-response').html(data).css("color","#509d24");
                  setTimeout(function () { location.reload(true);}, 3000);

                }else{
                  $('.contact-response').html(data).css("color","#ff0000");
                  setTimeout(function () { location.reload(true);}, 3000);
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });

        $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});



        
      });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-edit-profile"]) return;
  try {
    
  (function($){
      $(document).ready(function(){
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#customer_edit_profile").submit(function(){
          required = ["customer_first_name","customer_last_name"];
          email = $("#customer_email");
          for (i=0;i<required.length;i++) {
            var input = $('#'+required[i]);
            if ((input.val() == "") || (input.val() == emptyerror)) {
              input.addClass("needsfilled");
              input.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              input.removeClass("needsfilled");
            }
          }
          var newpassword = $('#customer_password').val();
          var conformpassword = $('#customer_confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if(newpassword!='' && newpassword.length <8){newpassword.addClass("needsfilled");newpassword.val('should contain 8 characters').attr('type', 'text');}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if(newpassword!=conformpassword){
            $('#customer_password').addClass("needsfilled");
            $("#customer_confirm_password").val("Confirm Password not match with password");
            $('#customer_confirm_password').addClass("needsfilled");
            return false;

          }else {

            var $form = $('#customer_edit_profile');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#update_profile').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#update_profile').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/index.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#update_profile').prop('disabled', false);

                if(data=='Sucess'){
                  alert('Profile Update Sucessfully.');
                }else{
                  alert(data);
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
        $("#customer_phone, #AddressPhoneNew, input[name='address[phone]']").bind("keypress", function (event) {
          var keyCode = event.which ? event.which : event.keyCode

          if ((keyCode == 43)) {
            return true;
          }else if (!(keyCode >= 48 && keyCode <= 57 )){
            return false;
          }

          var minLength = 12;
          var phone = $(this).val();
          if (phone.length > minLength){
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");$("#customer_password").attr('type', 'password');}});
    })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamond-baby-timer"] && !Shopify.designMode) return;
  try {
    
  // countdown script

  // Set Launch Date (ms)
  var stimermonths = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
  var snow = new Date(); 
  const slaunchDate = new Date(stimermonths[snow.getMonth()]+" "+snow.getDate()+ ", "+snow.getFullYear()+" 23:59:59 UTC-07:00").getTime();

  // End  Date
  const sendDate = new Date().getTime();

  // Context object
  const sc = {
      context: {},
      values: {},
      times: {}
  };

  // Convert radians to degrees
  function deg(d) {
      return (Math.PI / -180) * d - (Math.PI / 180) * 90;
  }

  function srender() {

      sc.context.seconds.clearRect(0, 0, 44, 44);
      sc.context.seconds.beginPath();
      sc.context.seconds.strokeStyle = "#fff";
      sc.context.seconds.arc(22, 22, 20, deg(0), deg(6 * (60 - sc.times.seconds)));
      sc.context.seconds.lineWidth = 2;
      sc.context.seconds.lineCap = "round";
      sc.context.seconds.stroke();

      sc.context.minutes.clearRect(0, 0, 44, 44);
      sc.context.minutes.beginPath();
      sc.context.minutes.strokeStyle = "#fff";
      sc.context.minutes.arc(22, 22, 20, deg(0), deg(6 * (60 - sc.times.minutes)));
      sc.context.minutes.lineWidth = 2;
      sc.context.minutes.lineCap = "round";
      sc.context.minutes.stroke();

      sc.context.hours.clearRect(0, 0, 44, 44);
      sc.context.hours.beginPath();
      sc.context.hours.strokeStyle = "#fff";
      sc.context.hours.arc(22, 22, 20, deg(0), deg(15 * (24 - sc.times.hours)));
      sc.context.hours.lineWidth = 2;
      sc.context.hours.lineCap = "round";
      sc.context.hours.stroke();

      // sc.context.days.clearRect(0, 0, 44, 44);
      // sc.context.days.beginPath();
      // sc.context.days.strokeStyle = "#fff";
      // sc.context.days.arc(22, 22, 20, deg(0), deg(360 - sc.times.days));
      // sc.context.days.lineWidth = 2;
      // sc.context.days.lineCap = "round";
      // sc.context.days.stroke();

  }



  function sinit() {

      // Get 2D contexts
      sc.context.seconds = document.getElementById('sseconds-canvas').getContext('2d');
      sc.context.minutes = document.getElementById('sminutes-canvas').getContext('2d');
      sc.context.hours = document.getElementById('shours-canvas').getContext('2d');
      // sc.context.days = document.getElementById('days-canvas').getContext('2d');

      // Get displayed values
      sc.values.seconds = document.getElementById('sseconds-value');
      sc.values.minutes = document.getElementById('sminutes-value');
      sc.values.hours = document.getElementById('shours-value');
      // sc.values.days = document.getElementById('days-value');


      if (sendDate < slaunchDate) {
          var x = setInterval(function () {
              // Get todays date and time (ms)
              const snow = new Date().getTime();

              // Get distance from snow to launchDate
              const distance = slaunchDate - snow;

              // Time calculations
              sc.times.days = Math.floor(distance / (1000 * 60 * 60 * 24));
              sc.times.hours = Math.floor(
                  (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
              sc.times.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              sc.times.seconds = Math.floor((distance % (1000 * 60)) / 1000);

              // sc.values.days.innerText = sc.times.days;
              sc.values.hours.innerText = sc.times.hours;
              sc.values.minutes.innerText = sc.times.minutes;
              sc.values.seconds.innerText = sc.times.seconds;

              if (distance < 0) {
                  clearInterval(x);
                  $("").addClass("time-expired");
              }

              srender(); // Draw!
          }, 100);
      }

  }
  sinit();
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doubleSlider"] && !Shopify.designMode) return;
  try {
    
(function($){  
//console.log('double');
$(document).ready(function(){
  $('.trulySlidemain').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        asNavFor: '.trulySlideNav'
    });
                                
    $('.trulySlideNav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: '.trulySlidemain',
        arrows: true,
        prevArrow: $(".trulySlideNav__btn.trulySlideNav__btnLeft"),
        nextArrow: $(".trulySlideNav__btn.trulySlideNav__btnRight"),
    });


 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doubleSliderRightMedia"] && !Shopify.designMode) return;
  try {
    
(function($){  
  //console.log('right')
$(document).ready(function(){
    $('.trulySlidemain-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        asNavFor: '.trulySlideNav-2'
    });
                                
    $('.trulySlideNav-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: '.trulySlidemain-2',
        arrows: true,
        prevArrow: $(".trulySlideNav-2__btn.trulySlideNav__btnLeft"),
        nextArrow: $(".trulySlideNav-2__btn.trulySlideNav__btnRight"),
    });

   

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doubleSliderleftSec"] && !Shopify.designMode) return;
  try {
    
(function($){  
//console.log('double2');
$(document).ready(function(){

    $('.trulySlidemain-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        asNavFor: '.trulySlideNav-3'
    });
                                
    $('.trulySlideNav-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: '.trulySlidemain-3',
        arrows: true,
        prevArrow: $(".trulySlideNav-3__btn.trulySlideNav__btnLeft"),
        nextArrow: $(".trulySlideNav-3__btn.trulySlideNav__btnRight"),
    }); 

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flip-product"] && !Shopify.designMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
//console.log('sssss');
 
  });
  })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullLengthTestimonial"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 $(".fullWide_testimonial").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1, } },
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }

    ]
});
 });
})(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_faq"] && !Shopify.designMode) return;
  try {
    
      (function ($) {
      $(document).ready(function () {
     	$(".accordion").click(function() {
    	var questionDiv = $(this);
    	var answerDiv   = $(this).next('.acdn_content');
    	var idx = $('.acdn_content').index(answerDiv);

    	$('.acdn_content').each(function(index, ansDiv) {
               if(index != idx && $(ansDiv).is(':visible')) {
    			$(ansDiv).slideUp(500, function() {
    				$(ansDiv).prev('.accordion').removeClass('accordion_open');
    			});
    		}
           });

    	if (answerDiv.is(':visible')) {
    		answerDiv.stop().slideUp(500, function() {
    			questionDiv.removeClass('accordion_open');
    		});
    	} else {
    	  questionDiv.addClass('accordion_open');
    	  answerDiv.stop().slideDown(500);
    	}
    });
        });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_order_save_strip"] && !Shopify.designMode) return;
  try {
    
   	var spd = 100;
  var spdVal = 10;
  var cntDown = 5 * 60 * spdVal;
  setInterval(function () {
  	var mn, sc, ms;
  	cntDown--;
  	if(cntDown < 0) {
  		return false;
  	}
  	mn = Math.floor((cntDown / spdVal) / 60 );
  	mn = (mn < 5 ? '0' + mn : mn);
  	sc = Math.floor((cntDown / spdVal) % 60);
  	sc = (sc < 5 ? '0' + sc : sc);
  	ms = Math.floor(cntDown % spdVal);
  	ms = (ms < 5 ? '0' + ms : ms);
  	var result = mn + ':' + sc;
  	document.getElementById('stopwatch').innerHTML = result;
  }, spd);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_results"] && !Shopify.designMode) return;
  try {
    
   	function getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
  	'total': t,
  	'days': days,
  	'hours': hours,
  	'minutes': minutes,
  	'seconds': seconds
    };
  }

  /*OFFER_TIMER*/
  function initializeClock(id, endtime) {
    var clock = document.getElementById(id);
   // var daysSpan = clock.querySelector('.days');
    var hoursSpan = clock.querySelector('.hours');
    var minutesSpan = clock.querySelector('.minutes');
    var secondsSpan = clock.querySelector('.seconds');
    function updateClock() {
  	var t = getTimeRemaining(endtime);
     // daysSpan.innerHTML = t.days;
  	hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
  	minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
  	secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
  	if (t.total <= 0) {
  	  clearInterval(timeinterval);
  	}
    }
    updateClock();
    var timeinterval = setInterval(updateClock, 1000);
  }
  var deadline = new Date(Date.parse(new Date()) + 60 * 120 * 1000);
  initializeClock('clockdiv3', deadline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_sticky_button"] && !Shopify.designMode) return;
  try {
    
   (function($){
    $(document).ready(function(){
      $(document).scroll(function() {
        if ($(window).width() <= 768) {
          $('.gdss_sticky_btn').addClass('gdss_sticky_show');
        }else{
          $('.gdss_sticky_btn').removeClass('gdss_sticky_show');
        }
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-sets"] && !Shopify.designMode) return;
  try {
    
  (function($){
      $(document).ready(function () {
//console.log('gift-sets');
   if ($(window).width() <= 989) {

          function replaceContent(x, z){
          // save the inner html of the first node in temp
          let temp = document.getElementById(x).innerHTML;
          // move the innerHtml of the second node into first node
          document.getElementById(x).innerHTML = document.getElementById(z).innerHTML;
          // replace the second node's inner html with temp (saved previously)
          document.getElementById(z).innerHTML = temp;
          }

          // replace the divs of id 2 and 4
          replaceContent("1", "5");
          replaceContent("2", "6");
          replaceContent("3", "7");
          replaceContent("4", "8");
          // replaceContent("gift-products-9", "gift-products-10");

      }

          // Only One video At a time
        $('.trulyTab li').click(function () {
          var tab_id = $(this).attr('data-tab');
           // for video paly on tabs

          $("#" + tab_id).find('video').get(0).play()
          $("#" + tab_id).siblings().find('video').get(0).pause()
          $("#" + tab_id).find('.TabVideo').find('.playpauseBtn').addClass('active')


      });
          // Only One video At a time
    function videoPlay() {
          $(".trulyTab__cntnt.current").find('video').get(0).play()
      }
      videoPlay()
   });
     
    })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-glazed_donut_shave_set_v1"] && !Shopify.designMode) return;
  try {
    
   (function ($) {
     $(document).scroll(function() {
   	if ($(this).scrollTop() > 110){
   		$('.top-fix-bar').addClass('fixed-nav');
   	}else{
   		$('.top-fix-bar').removeClass('fixed-nav');
   	}
   });
   	$(".btn_scorall").click(function() {
  	$('html, body').animate({
  		scrollTop: $("#select_pkg").offset().top - 50
  	}, 2000);
  });
  // var scroll = new SmoothScroll('a[href*="#"]', {
  // 	speed: 500,
  // });
   })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function ($) {
    $(document).ready(function () {
      let scrollheight;
      if (window.matchMedia('(max-width: 750px)').matches) {
        scrollheight = 120;
      } else {
        scrollheight = 100;
      }
      let navhldr = $('.headerSection');
      let windowtop = scrollheight;
      // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
      function navbarCheck() {
        if ($(window).scrollTop() >= windowtop) {
          let navhldrHeight = navhldr.innerHeight();
          navhldr.addClass('sticky');
          $('.headerFixed__wrap').css('height', navhldrHeight + 'px');
          $('.recommendedFilter__Row').css('top', navhldrHeight + 'px');
          $('#template-shave-starter-pack .sticky_sec').css('top', navhldrHeight - 1 + 'px');
        } else {
          navhldr.removeClass('sticky');
          $('.headerFixed__wrap').css('height', 'auto');
          $('.recommendedFilter__Row').css('top', 'auto');
          $('#template-shave-starter-pack .sticky_sec').css('top', 'auto');
        }
      }
      $(window).scroll(function () {
        navbarCheck();
      });

      $(window).ready(function () {
        navbarCheck();
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_glazed_donut"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
  //console.log('header');
 let scrollheight
            if(window.matchMedia('(max-width: 750px)').matches) {
                scrollheight = 120
            }else{
                scrollheight = 100
                
            }
            
            let navhldr = $('.headerSection');
            let windowtop = scrollheight;
          
            
            // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
            function navbarCheck() {
                if ($(window).scrollTop() >= windowtop) {
                      let navhldrHeight = navhldr.innerHeight()
                    navhldr.addClass('sticky');
                    $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                    $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                } else {
                    navhldr.removeClass('sticky');
                    $(".headerFixed__wrap").css("height" ,"auto")
                    $(".recommendedFilter__Row").css("top" ,"auto")
                }
            }
            
            // navbarCheck()
            $(window).scroll(function () {
                navbarCheck()
            });  

            // navbarCheck()
            $(window).ready(function () {
                navbarCheck()
                //console.log("Hello World!");
            });   
            
            

            var new_scroll_position = 0;
            var last_scroll_position;
            var header = document.getElementById("header");

            window.addEventListener('scroll', function(e) {
                last_scroll_position = window.scrollY;

                if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                    header.classList.remove("slideDown");
                    header.classList.add("slideUp");
                    $("body").addClass("slideDownBody");
                    

                // Scrolling up
                } else if (new_scroll_position > last_scroll_position) {
                    header.classList.remove("slideUp");
                    header.classList.add("slideDown");
                    $("body").removeClass("slideDownBody");
                }

                new_scroll_position = last_scroll_position;
            });

  });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_mini_offers_landing"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 let scrollheight
            if(window.matchMedia('(max-width: 750px)').matches) {
                scrollheight = 120
            }else{
                scrollheight = 100
                
            }
            
            let navhldr = $('.headerSection');
            let windowtop = scrollheight;
          
            
            // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
            function navbarCheck() {
                if ($(window).scrollTop() >= windowtop) {
                      let navhldrHeight = navhldr.innerHeight()
                    navhldr.addClass('sticky');
                    $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                    $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                } else {
                    navhldr.removeClass('sticky');
                    $(".headerFixed__wrap").css("height" ,"auto")
                    $(".recommendedFilter__Row").css("top" ,"auto")
                }
            }
            
            // navbarCheck()
            $(window).scroll(function () {
                navbarCheck()
            });  

            // navbarCheck()
            $(window).ready(function () {
                navbarCheck()
                //console.log("Hello World!");
            });   
            
            

            var new_scroll_position = 0;
            var last_scroll_position;
            var header = document.getElementById("header");

            window.addEventListener('scroll', function(e) {
                last_scroll_position = window.scrollY;

                if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                    header.classList.remove("slideDown");
                    header.classList.add("slideUp");
                    $("body").addClass("slideDownBody");
                    

                // Scrolling up
                } else if (new_scroll_position > last_scroll_position) {
                    header.classList.remove("slideUp");
                    header.classList.add("slideDown");
                    $("body").removeClass("slideDownBody");
                }

                new_scroll_position = last_scroll_position;
            });

  });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bagBathSection"] && !Shopify.designMode) return;
  try {
    
 (function($){
    //console.log('bagslider');
     $(document).ready(function(){
      $(".iconicbagSlider").slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 751,
                    settings: {
                        slidesToShow: 1.05,
                        slidesToScroll: 1,
                       useTransform: false,
                        // centerMode: true, 
                        // centerPadding: "60px",  
                        infinite: false,
                        dots: true,
                    }
                },
            ]
        });
        });
      })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeRotationalBar"] && !Shopify.designMode) return;
  try {
    
(function($){ 
//console.log('rotationalbar');
$(document).ready(function(){
const smallUsps = Array.from(document.querySelectorAll('.all-usp__Style .single-usp__Style'));
        let showElmIndex = 0;
        //console.log(smallUsps);
        setInterval(() => {
            smallUsps.map((item, index) => {
                if (index === showElmIndex) {
                    item.style.display = 'flex';
                    item.style.height = "initial" ;
                    item.style.width = "initial" ;
                    item.style.opacity = "1" ;

                } else {
                    // item.style.display = 'none';
                    item.style.height = "0" ;
                    item.style.width = "0" ;
                    item.style.opacity = "0" ;
                }
            })
            showElmIndex === smallUsps.length - 1 ? showElmIndex = 0 : showElmIndex++;
        }, 2500)

        });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_skin_loving_essentials"] && !Shopify.designMode) return;
  try {
    
  (function ($) {
    $(document).ready(function () {
      $('.product_variant-group .color-options input').first().prop('checked', true).trigger('change');
      $('.color-options input').on('change', function () {
        var newImg = $(this).data('img');
        var UpdateId = $(this).attr('id');
        var DataPrice = $(this).data('price');
        var DataPharse = $(this).data('phrase');
        var DataHandle = $(this).data('handle');
        var DataProductavailable = $(this).data('productavilable');
        var DataTitle = $(this).data('title');
        $(this).closest('.into_product-slide').find('.into_product_image img').attr('src', newImg);
        $(this).closest('.into_product_item').find('form.Shopify-product-form').find('input[name=id]').val(UpdateId);
        $(this).closest('.into_product_item').find('.into_product_meta_wrap').find('p').text(DataPharse);
        $(this).closest('.into_product_item').find('a.into_product_image').attr('href', DataHandle);
        $(this).closest('.into_product_item').find('.into_product_title a').attr('href', DataHandle);
        $(this).closest('.into_product_item').find('.into_product_meta_wrap').find('h3').text(DataTitle);

        if (DataProductavailable === false) {
          //console.log('ifcase', DataProductavailable);
          $(this)
            .closest('.into_product_item')
            .find('form.Shopify-product-form')
            .find('button.common-btn')
            .html(`<span>SOLD OUT ${DataPrice}</span>`);
          $(this)
            .closest('.into_product_item')
            .find('form.Shopify-product-form')
            .find('button.common-btn')
            .attr('disabled', true);
        } else {
          //console.log('eselcase', DataProductavailable);
          $(this)
            .closest('.into_product_item')
            .find('form.Shopify-product-form')
            .find('button.common-btn')
            .html(`<span>ADD TO BAG  ${DataPrice}</span>`);
          $(this)
            .closest('.into_product_item')
            .find('form.Shopify-product-form')
            .find('button.common-btn')
            .attr('disabled', false);
        }
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-repeter"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function () {
    // Wait for all videos to be loaded and ready
  var videos = document.querySelectorAll('.mydVideos');
  
  videos.forEach(function (video) {
    video.addEventListener('canplay', function () {
      video.play();
    });
  });
});
  })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function($){
   $(document).ready(function(){
     //console.log('sdsdfsdfsdsd');
   });
      })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencer"] && !Shopify.designMode) return;
  try {
    
  (function($){
      $(document).ready(function(){
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#Influencer_request").submit(function(){
         required = ["first_name","last_name","password","confirm_password","custom_83641","custom_82327","custom_82326","custom_82324","custom_81275","conversion_trigger_coupon"];
          email = $("#email");
          payemail = $("#paypal_email_80624");
          for (i=0;i<required.length;i++) {
            var input = $('#'+required[i]);
            if ((input.val() == "") || (input.val() == emptyerror)) {
              input.addClass("needsfilled");
              input.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              input.removeClass("needsfilled");
            }
          }
          var newpassword = $('#password').val();
          var confirmpassword = $('#confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if  (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(payemail.val())) {payemail.addClass("needsfilled");payemail.val(emailerror);}

          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if(newpassword!=confirmpassword){
            $('#password').addClass("needsfilled");
            $('#confirm_password').addClass("needsfilled");
            return false;

          }
          else {

            var $form = $('#Influencer_request');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#Influencer_request').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#Influencer_request').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/refersion.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#Influencer_request').prop('disabled', false);

                if (data.indexOf('Thanks') > -1) {
                  $('.infulencer-response').html(data).css("color","#509d24");
                  $('.infulencer-response p').css("color","#509d24");
                  $('#Influencer_request')[0].reset();
                  $('.infulencer-response').delay(5000).fadeOut('slow');

                }else{
                  $('.infulencer-response').html(data).css("color","#ff0000");
                  $('.infulencer-response p').css("color","#ff0000");
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landingpagemedia"] && !Shopify.designMode) return;
  try {
    
 
(function($){   
$(document).ready(function(){  
$(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
      $(".sticky-wrap").addClass('sticky-show')
      //$(".head-order-btn").addClass('sticky-hide-head')
    } else {
      $(".sticky-wrap").removeClass('sticky-show')
     // $(".head-order-btn").removeClass('sticky-hide-head')
    }
});
  

});
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-oil-taste-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    function initSlick() {
      if ($(window).width() <= 750) {
        if (!$('.banner_taste-wrapper').hasClass('slick-initialized')) {
          $('.banner_taste-wrapper').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000
          });
        }
      } else {
        if ($('.banner_taste-wrapper').hasClass('slick-initialized')) {
          $('.banner_taste-wrapper').slick('unslick');
        }
      }
    }
    initSlick();
    $(window).on('resize', function () {
      initSlick();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
(function ($) {
$(document).ready(function () {
var CustomerId = $('#customerid').val();
//console.log(customerid);
$.ajax({
url: 'https://mytrulydeals.com/trulybeauty/inveterate/memberdetails.php',
method: 'POST',
dataType: 'json',
data: {
   customerId: CustomerId
},
success: function(response) {
   //console.log('response',response);
   //console.log('credit',response.credits);
   //console.log('nextbillingdate',response.nextBillingDate);
   var CreditsScore = response.credits
   if(CreditsScore === null || CreditsScore === '' || CreditsScore === ' '){
      $('#CreditScore').text('$0');
   }else{
      $('#CreditScore').text(CreditsScore);
   }
   $('#NextRenewl').text(response.nextBillingDate);
},
error: function(xhr, status, error) {   
   console.error("Error loading data:", status, error);
}
});

//console.log('accountusesr');
loadstampedreviews();

// recent view product section
Shopify.Products.showRecentlyViewed( { howManyToShow:10, onComplete: function() {
     var RVlength = $('.Recentlyviewed .into_product-slide').length;
    //console.log('RVlength',RVlength); 
   if(RVlength>0){jQuery('.recentview_product').removeClass('d-none');}else{jQuery('.recentview_product').addClass('d-none');}  
    $(".Recentlyviewed").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: !1,
        dots: false,
        fade: false,
        infinite: false,
        responsive: [
        { breakpoint: 1251, settings: { slidesToShow: 3 } },
        { breakpoint: 1101, settings: { slidesToShow: 2 } },
        { breakpoint: 750, settings: { slidesToShow: 1.2 } },
        ],
    });
}
});

});

}(jQuery));   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function ($) {
    window.onload = () => {
      typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
    };

    $(document).ready(function () {
      // Initialize intl-tel-input
      const phoneInputField = document.querySelector('#AddressPhoneNew');
      const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
      const iti = window.intlTelInput(phoneInputField, {
        initialCountry: 'auto',
        hiddenInput: () => ({ phone: 'address[phone]' }),
        geoIpLookup: (callback) => {
          fetch('/browsing_context_suggestions.json')
            .then((res) => res.json())
            .then((data) => callback(data.detected_values.country.handle))
            .catch(() => callback('us'));
        },
        strictMode: true,
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js',
      });

      $('.add-addressBtn').click(function () {
        $(this).toggleClass('active-filter');
        $(this).parents('.addNew__Address').find('.mainAddress__form').slideToggle();
      });

      $('.cancel-btn').click(function () {
        $(this).parents('.addNew__Address').find('.mainAddress__form').slideUp();
        $('.add-addressBtn').removeClass('active-filter');
      });

      //check add address required

      $('form#address_form_new').submit(function () { 
        var minLength = 15;
        var errormsg = 'This field is requried.';
        required = [
          'AddressFirstNameNew',
          'AddressLastNameNew',
          'AddressAddress1New',
          'AddressCityNew',
          'AddressZipNew',
          'AddressCountryNew',
        ];
        for (i = 0; i < required.length; i++) {
          var input = $('#address_form_new #' + required[i]);
          if (input.val() == '' || input.val() == errormsg) {
            input.addClass('needsfilled');
            input.val(errormsg);
          } 
        }

        var phoneinput = document.getElementById("AddressPhoneNew");
        if (!phoneinput.value.trim()) {
           phoneinput.classList.add('needsfilled');
           phoneinput.value = 'This field is requried.';
        } else if (iti.isValidNumber()) {
          phoneinput.classList.remove('needsfilled');
        } else {
          const errorCode = iti.getValidationError();
          const msg = errorMap[errorCode] || "Invalid number";
          phoneinput.classList.add('needsfilled');
          phoneinput.value = msg;
        }

        if ($(':input').hasClass('needsfilled')) {
          return false;
        } else {
          $(this).closest('form').submit();
          return true;
        }
      });

      $(":input").focus(function () {
      if ($(this).hasClass("needsfilled")) {
        $(this).val("");
        $(this).removeClass("needsfilled");
      }
    });

    });

    $(document).ready(function () {
     
      $("#customer_phone, #AddressPhoneNew, input[name='address[phone]']").bind('keypress', function (e2) {
        var keyCode = e2.which ? e2.which : e2.keyCode;

        if (keyCode == 43) {
          return true;
        } else if (!(keyCode >= 48 && keyCode <= 57)) {
          return false;
        }

        var minLength = 15;
        var phone = $(this).val();
        if (phone.length > minLength) {
          return false;
        }
      });
    });
    $(':input').focus(function () {
      if ($(this).hasClass('needsfilled')) {
        $(this).val('');
        $(this).removeClass('needsfilled');
        $('#customer_password').attr('type', 'password');
      }
    });
  })(jQuery);

  $(document).on('click', '.cancel_btn', function () {
    $('html').removeClass('noscroll');
    $('#' + $(this).data('id')).closePopup({
      anim: !$(this).attr('data-animation') || $(this).data('animation') == null ? 'fade' : $(this).data('animation'),
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-tiktok"] && !Shopify.designMode) return;
  try {
      
(function($){ 
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
  });
});  

$(document).ready(function(){
$(".tikvido").each(function() { 
     if($('.tikvido').hasClass('active')){
       $(".tiktokvideotags .all_btn").removeClass('active');
     }else{
       $('.tiktokvideotags .all_btn').addClass('active')
     }   
    });   
  
 $(document).on('click',".boxVideo__btn",function () {
          var video = $(this).parents('.tiktokChallangeVBox').find("video").get(0);
          video.addEventListener('ended', myHandler, false);
          $(this).toggleClass("active");
          if (video.paused === true) {
            video.play();
            $(this).parents('.tiktokChallangeVBox').addClass("active");
          } else {
            video.pause();
            $(this).parents('.tiktokChallangeVBox').removeClass("active");
          }
          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari){
            video.addEventListener('ended',function(){
              setTimeout(function(){ video.load();}, 1000);
              $(this).parents(".tiktokChallangeVBox").find(".boxVideo__btn").removeClass("active");
              $(this).parents('.tiktokChallangeVBox').removeClass("active");
            });
          }
          function myHandler(e) {
            $(this).parents(".tiktokChallangeVBox").find(".boxVideo__btn").removeClass("active");
            $(this).parents('.tiktokChallangeVBox').removeClass("active");
          }
        });
  
        $(document).on("click", ".tiktokreadBtn",function () {
          $(this).parent().siblings().removeClass("d-none");
          $(this).parent().addClass("d-none");
        });
        $(document).on("click",".indireviews",function () {          
          $('.reviewresponse').html('<div class="smileyloader text-align-center p-0 mt-2"><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/smile.png?v=1632987124" class="smileyloader__img" alt="" width="50" height="50"></div>');
          var proid = $(this).attr('data-proid');
          //alert(proid);
          $.ajax({
            url: "https://stamped.io/api/widget/reviews?take&storeUrl=www.trulybeauty.com&minRating=4&apiKey=pubkey-y0bQR825X6K52BT67V84qf3OGso3o0&productId="+proid+"&sortReviews=photos",
            type: 'GET',
            dataType: 'json',
            success: function (reviewsresponse) {
              reviewproduct='';
              jQuery.each( reviewsresponse.data, function( i, val ) {
                reviewproduct +='<div class="p-4 px-0 mb-2 Product__ReviewBox border0"><div class="gridrow">';
                if(typeof val.reviewUserPhotos !== "undefined" && val.reviewUserPhotos !== null && val.reviewUserPhotos !== ''){
                  var firstimg = val.reviewUserPhotos.split(',');
                  reviewproduct +='<div class="column-12 column-sm-3 column-md-3 column-lg-2"><div class="textCenter Product__ReviewImg"><img src="https://cdn.stamped.io/tr:h-180,/uploads/photos/'+firstimg[0]+'"class="full_img"></div></div>';
                }
                reviewproduct +='<div class="column-12 column-sm-9 column-md-9 column-lg-10"><div class="ProductReview__cntnt"><div class="d-flex justifyBetween ProductReview__starDate"><span class="stamped-starrating stamped-badge-starrating" aria-hidden="true">';
                if(val.reviewRating==5){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>';
                }
                if(val.reviewRating==4){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                if(val.reviewRating==3){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                if(val.reviewRating==2){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                if(val.reviewRating==1){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                reviewproduct +='</span><p>'+val.reviewDate+'</p></div> <div class="Review__contentHolder"><h5 class="textUppercase">'+val.reviewTitle+'</h5><p>'+val.reviewMessage+'</p><h5 class="m-0 py-3 BuyerVerified">'+val.author+'<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/verified.png?v=1632733611">Verified Buyer</span></h5></div><div class="d-flex justifyBetween Review__recomendHelp"><div class="Review__recomended"><p><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/recommend.png?v=1632733611">Yes,<span>I recommend this product</span></p></div><div class="Review__helpful"><p>Was this review helpful?<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/thumsup.png?v=1632733611"></span>'+val.reviewVotesUp+'<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/greythumdown.png?v=1656067772"></span>'+val.reviewVotesDown+'</p></div></div></div></div></div></div>';
              });
              $('.reviewresponse').html(reviewproduct);
              //$('.totlreview').html(reviewsresponse.total);
              //$('.rating').html(reviewsresponse.rating);
            },
            timeout: 5000000, // sets timeout to 5 seconds

          });
        });

      });
    })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bundle-builder"] && !Shopify.designMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
//console.log('builderpage');
       $.ajax({ type: 'POST',  dataType: 'json',  url: '/cart/clear.js'  }); 
     $('.qtyInput').val('0');
 // qtyButton plus/mins
let totalCount = 0;
let subtotal = 0;
  let saving = 0;
      let totalsaving= 0;
 let gfiftprice = 0;      
  let discount_pro = '';
$(document).on('click', '.bt_ss', function () {
  
    let rp = parseFloat($(this).parents('.qtyCalculator').attr('data-rp'));
    var qty = parseInt($(this).parents('.qtyCalculator, .qtyCal').find('.qtyInput').val());
    var act = $(this).data('type');
    var line = $(this).data('line');
       if (act == 'plus') {
        totalCount++;
         subtotal = parseFloat(parseFloat(subtotal) + rp).toFixed(2) ;
         saving = parseFloat(parseFloat(saving) + rp).toFixed(2) ;
          if (totalCount == 2) {
            $('.unlock-gift-1').addClass('show--gift');
              $('.unlock-gift-1 .flavorValue').val(1);
             gfiftprice = 1; 
          if(gfiftprice == 1){
               saving = parseFloat(parseFloat(saving) + 20).toFixed(2);   
               gfiftprice = 0
             }   }
        if (totalCount == 3) {
          $('.unlock-gift-2').addClass('show--gift');
           $('.unlock-gift-2 .flavorValue').val(1);
           gfiftprice = 1; 
          if(gfiftprice == 1){
               saving = parseFloat(parseFloat(saving) + 10).toFixed(2);   
               gfiftprice = 0
             }   }
        if (totalCount == 6) {
              $('.unlock-gift-3').addClass('show--gift');
            $('.unlock-gift-3 .flavorValue').val(1);
           gfiftprice = 1; 
          if(gfiftprice == 1){
               saving = parseFloat(parseFloat(saving) + 250).toFixed(2);   
               gfiftprice = 0
             }    }
    } else {
        if (totalCount >= 1 && qty > 0) {
            totalCount--;
             subtotal = parseFloat(parseFloat(subtotal) - rp).toFixed(2);
          //console.log(totalCount);
           if (totalCount == 0) {
                 gfiftprice = 0; 
                 saving = 0;
              }
             if (totalCount == 1) {
                $('.unlock-gift-1').removeClass('show--gift');
            
                $('.unlock-gift-1 .flavorValue').val(0);
                  gfiftprice = 1;  
                 if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp - 10).toFixed(2);   
                  gfiftprice = 0
                }  
              }
           if (totalCount == 2) {
              $('.unlock-gift-2').removeClass('show--gift');
                   gfiftprice = 1; 
                   if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp - 20).toFixed(2);   
                  gfiftprice = 0
                }  
               }
            if (totalCount == 3) {
               // $('.unlock-gift-2').removeClass('show--gift');
                 $('.unlock-gift-2 .flavorValue').val(0);
                  gfiftprice = 1; 
                   if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp ).toFixed(2);   
                  gfiftprice = 0
                }  
               }
           if (totalCount == 4) {
              //  $('.unlock-gift-2').removeClass('show--gift');
                 $('.unlock-gift-2 .flavorValue').val(0);
                  gfiftprice = 1; 
                   if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp ).toFixed(2);   
                  gfiftprice = 0
                }  
               }
            if (totalCount == 5) {
                $('.unlock-gift-3').removeClass('show--gift');
                $('.unlock-gift-3 .flavorValue').val(0);
               gfiftprice = 1; 
                if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp - 250).toFixed(2);   
                  gfiftprice = 0
                }  
             }
        } 
  }
  



  
    if (qty > 9999) { var qty = 9999 }
    if (act == 'plus') { if (qty < 9999) { qty++; } } else {
        if (qty > 0) { qty--; }
    }
 
    if (qty >= 1) {
        $(this).parents('.bundle-select--box').addClass('select-bundle');
       }
    else {
        $(this).parents('.bundle-select--box').removeClass('select-bundle');
    }
    qty = (isNaN(qty)) ? 1 : qty;

    $(this).parent('.qtyCalculator').find('.qtyInput').val(qty);
    $('.trulySidebarModel__cartList').addClass('active');
    $('.cartTable').addClass('active');
    var variantid = parseInt($(this).data('variantid'));
    
  totalsaving = parseFloat(saving - subtotal ).toFixed(2);
    //  console.log(totalsaving);
    if(totalsaving == 0.00){
      $('.stock--actionTxt.medium.bundle-cartTotal-inner').css('display','none');
    }else{
      $('.stock--actionTxt.medium.bundle-cartTotal-inner').css('display','flex');
    }
    if($('.unlock-gift-1').hasClass("show--gift") && $('.unlock-gift-2').hasClass("show--gift") && $('.unlock-gift-3').hasClass("show--gift")){
        discount_pro = 'BB_THREE';
  $('.gift_count_text').html(3);
         }
    else if($('.unlock-gift-1').hasClass("show--gift") && $('.unlock-gift-2').hasClass("show--gift")){
         discount_pro = 'BB_TWO';
       $('.gift_count_text').html(2);
     }
    else if ($('.unlock-gift-1').hasClass("show--gift"))  {
       discount_pro = 'BB_ONE';
       $('.gift_count_text').html(1);
         }
   else{
        discount_pro = ''
     }
    var save = ((parseInt(saving)-parseInt(subtotal))/parseInt(saving))*100 ;
    var savepersentage =  save.toFixed(2);
     $(".subtotal").html(subtotal)
     $(".saving").html(saving)
      $(".savepersentage").html(savepersentage)
 if (totalCount >= 1) {
  $('.addtocart_ss').removeClass('disabled');
 }else{
   $('.addtocart_ss').addClass('disabled');
 }
 });
 $(' .addtocart_ss').on('click', function(){
  var inputs = $(".flavorValue");
  var variants = [];
        for(var i = 0; i < inputs.length; i++){
            if($(inputs[i]).val()>=1)
                variants.push({
                    quantity: $(inputs[i]).val(),
                    id: $(inputs[i]).data('variantid'),
                   });
              }
       $.ajax({
                url: "/cart/add.js",
                type: 'POST',
                dataType: 'json',
                data: { items: variants },
                success: function (response) {
               //ajaxfetchCart();
              document.location.href = '/cart/checkout?discount='+discount_pro;
                    }
                });
 
});
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'scroll',
      offset: 1000,
      callback : loadstampedreviews
    });
  });
  function loadstampedreviews(){
    //console.log('sdsdfsd');
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
          //  lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      // Possibly fall back to event handlers here
    }
       StampedFn.reloadUGC();
  }
  (function($){
  $(document).ready(function(){
  //console.log('select');
  $(document).on("click", ".select__custom", (function () {
  $(this).toggleClass("openDropdown"),
  $(this).find(".product__shop__categoryList").toggle()
    }
   ));
  });
        })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
     method: 'scroll',
    offset: 1000,
    callback : loadstampedreviews
  });
});
function loadstampedreviews(){
  //console.log('sdsdfsd');
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
        //  lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Possibly fall back to event handlers here
  }
     StampedFn.reloadUGC();  
}   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-2024"] && !Shopify.designMode) return;
  try {
    
 
(function($){    

   $(document).ready(function() {
     $('.product-form__variants').on('change', function() {
      var selectedValue = $(this).val();
    $('.subscription_product').val(selectedValue);
     $('.subscription_var_price').addClass('var_change');
  });
});
  
  function productvariation_switch(){
     
          var variationID = $('.product-form__variants option:selected').val();
          var productUrl = $('.productDetail input[name="producthandle"]').val();
          var onetimesubscribeoption = $('input[type=radio][name=sellingplan_option]:checked').val();
          jQuery.getJSON(productUrl + '.js', function(product) {
            $.each(product.variants, function(i){
              if( product.variants[i].id == variationID ){
                var price = product.variants[i].price;
            var compare_price = product.variants[i].compare_at_price;
                if(product.variants[i].featured_media!=null){
                  var variantimageID = product.variants[i].featured_media.id;

             
                }
            if(typeof onetimesubscribeoption !== "undefined" && onetimesubscribeoption=='subscription'){ //
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                   $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                   $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                    $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  var sellingplan = $('select[name="selling_plan"]').val();
                  $.each(product.variants[i].selling_plan_allocations, function(j){
                    if(sellingplan==product.variants[i].selling_plan_allocations[j].selling_plan_id){
                      var price = product.variants[i].selling_plan_allocations[j].price;
                      $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                    }
                  });
                }else{
                if(product.variants[i].selling_plan_allocations!=''){
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                  $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                        $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                }
                  $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(price, theme.moneyFormat));

                }
                if(variantimageID){
                  $('.productSliderNav img').each(function(){
                    if ($(this).attr("id") == variantimageID) {
                      $(this).click();
                      $(this).parent().parent().addClass('slick-current');
                    }
                  });
                }
    // console.log("price:",price);
    // document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", price);
    // window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    // window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
              }
            })

          });
        }
$(document).ready(function(){  
productvariation_switch();
$('.product-form__variants').on('change', function() {
productvariation_switch();
});
  
$(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
      $(".sticky-wrap").addClass('sticky-show')
      //$(".head-order-btn").addClass('sticky-hide-head')
    } else {
      $(".sticky-wrap").removeClass('sticky-show')
     // $(".head-order-btn").removeClass('sticky-hide-head')
    }
});
  

});
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'scroll',
        offset: 1000,
         callback : loadstampedreviews
      });
    });
    function loadstampedreviews(){
      var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
      if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
            //  lazyImage.srcset = lazyImage.dataset.srcset;
              lazyImage.classList.remove("lazy");
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      } else {
        // Possibly fall back to event handlers here
      }
         StampedFn.reloadUGC();
    }
  // sortby
  $(".sortBy_fl").click(function() {
              var is_open = $(this).hasClass("open");
              if (is_open) {
                  $(this).removeClass("open");
              } else {
                  $(this).addClass("open");
              }
  });

  $(".sortBy_fl li").click(function() {
              var selected_value = $(this).html();
              var first_li = $(".sortBy_fl li:first-child").html();

              $(".sortBy_fl li:first-child").html(selected_value);
              $(this).html(first_li);
  });

  $(document).mouseup(function(event) {
              var target = event.target;
              var select = $(".sortBy_fl");

              if (!select.is(target) && select.has(target).length === 0) {
                  select.removeClass("open");
              }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-slider"] && !Shopify.designMode) return;
  try {
    
  (function($){
    $(document).ready(function(){
     
  function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 1;
  //console.log(firstElement);
  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}

if($(window).width() < 750) {
    window.addEventListener('load', Marquee('.marquee_scroll', 0.1))
} else {
    window.addEventListener('load', Marquee('.marquee_scroll', 0.2))
}
      
    });
 
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minis-offer-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function($){   
$(document).ready(function(){
$(".shop_slider_three").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    infinite: true,

    responsive: [
    { breakpoint: 1101, settings: { slidesToShow: 3,} },
    { breakpoint: 751, settings: { slidesToShow: 2,} },
    { breakpoint: 481, settings: { slidesToShow: 2,slidesToScroll: 2,arrows: false,dots: true} },  
    ],
    });
  $('body').on('click', '.slick-arrow', function () {
    loadstampedreviews();
})
    });
})(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minis_client_logo"] && !Shopify.designMode) return;
  try {
    
  (function($){   
$(document).ready(function(){
  //console.log('sliderlogosse')
$(".loved--brand").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: true,
    responsive: [
        { breakpoint: 989, lazyLoad: 'progressive', settings: "unslick", },
    ],
    });
$(".logo--carousel").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: true,
    responsive: [
        { breakpoint: 989, lazyLoad: 'progressive', settings: "unslick", },
    ],
});
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minis_reviews"] && !Shopify.designMode) return;
  try {
    
  (function($){   
$(document).ready(function(){
  $(".fullWide_testimonial").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1, }},
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 }}
    ]
});
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npl-main-product"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.modal-accordion-content').on('click', function () {
      const $accordion = $(this).closest('.modal-accordion');
      const $answer = $accordion.find('.modal-question-answer');

      if ($accordion.hasClass('active')) {
        $accordion.removeClass('active');
        $answer.hide();
        return;
      }

      $('.modal-accordion.active').removeClass('active').find('.modal-question-answer').hide();

      $accordion.addClass('active');
      $answer.show();
    });

    $('#learn_more').on('click', function () {
      $('.outer_modal_screen').addClass('active');
    });

    $('.back-icon').on('click', function () {
      closeOuterModal();
      closeinnerModal();
    });

    $('.modal_overlay').on('click', function (e) {
      if (e.target === this) {
        closeOuterModal();
      }
    });

    function closeOuterModal() {
      $('.outer_modal_screen').removeClass('active');
    }

    $('.modal-provider-info').on('click', function () {
      $('.outer_modal_screen').removeClass('active');

      const target = $(this).data('target');

      $('.inner-modal').removeClass('active');

      $('.back-inner-icon').on('click', function () {
        closeinnerModal();
        $('.outer_modal_screen').addClass('active');
      });

      $('#' + target).addClass('active');
    });

    $('.inner-close').on('click', function () {
      $(this).closest('.inner-modal').removeClass('active');
    });
    function closeinnerModal() {
      $('.inner_modal').removeClass('active');
    }
  // customer viewd functoin
    function getRandomProductViewedCount(min, max) {
      const minCeiled = Math.ceil(min);
      const maxFloored = Math.floor(max);
      var productviewed = Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled); 
      $('#product-viewed').html(productviewed);
    }
    setInterval( function(){ getRandomProductViewedCount(1000,2000); } , 5000);  
  // document closed here
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  
    function GetURLParameter(sParam){
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split('&');
      for (var i = 0; i < sURLVariables.length; i++){
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam){
          return sParameterName[1];
        }
      }
    }
    var referenceids = GetURLParameter('referenceids');

    $(document).ready(function() {

      $.ajax({
        url: "https://mytrulydeals.com/trulybeauty/order-tracking.php",
        type: 'POST',
        data: {referenceid:referenceids},
        async: true,
        success: function (response) {          //console.log("response",response); 
          if (response=='null') {
          $('.orderTrackingResponse span').html('Not able to gather the details. Please try again after some time.');
          }else{
           var totaltracking = JSON.parse(response).length;
          var trackresponse ='';
          $.each(JSON.parse(response), function(index, value) {
            var ExpectedDelivery = value.expectedDelivery; //alert(ExpectedDelivery);
            var DeliveryDate = value.deliverydate;
            var tracklist = value.trackList;
            var trackingNumber = value.trackingNumber!==null ? value.trackingNumber : "NA";
            var shippingstatus = value.shippingStatus;
            var monthNames = ["January", "February", "March", "April", "May", "June",  "July", "August", "September", "October", "November", "December"];
            var monthshortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
            
            if(shippingstatus=='Accepted'){
              var titlefirst = 'Estimated Delivery';
              var currenStatus = 'Data Received';
              var statusbar1 = 'active';
            }else if(shippingstatus=='In Transit'){
              var titlefirst = 'Estimated Delivery';
              var currenStatus = 'In Transit';
              var statusbar1 = 'selected';
              var statusbar2 = 'active';
            }else if(shippingstatus=='Out For Delivery'){
              var titlefirst = 'Estimated Delivery';
              var currenStatus = 'Out For Delivery';
              var statusbar1 = 'selected';
              var statusbar2 = 'selected';
              var statusbar3 = 'active';
            }else if(shippingstatus=='Delivered'){
              var titlefirst = 'Delivered';
              var currenStatus = 'Delivered';
              var statusbar1 = 'selected';
              var statusbar2 = 'selected';
              var statusbar3 = 'selected';
              var statusbar4 = 'active';
              var d = new Date(DeliveryDate);
              var weekday = weekday[d.getDay()];
              var monthname = monthNames[d.getMonth()];
              var estimateDay = d.getDate();
              var estimateDate = weekday+' <br> '+monthname;
            }
            if (ExpectedDelivery){
              var d = new Date(ExpectedDelivery.slice(0, -6));
              var weekday = weekday[d.getDay()];
              var monthname = monthNames[d.getMonth()];
              var estimateDay = d.getDate();
              var estimateDate = weekday+' <br> '+monthname;
            }else if(shippingstatus!='Delivered'){
              var estimateDay = 'NA';
              var estimateDate = '';
            }
            if(tracklist==''){
              trackdetail ='<li>No Tracking yet.</li>';
            }else{
              tracklist.reverse();
              trackdetail='';
                for (i = 0; i <tracklist.length; i++) {
                var list='';
                list += '<li><span class="orderTrackingBox__shippingDate"><span>';
                if (typeof tracklist[i]["timestamp"]!== "undefined"){
                  var d = new Date(tracklist[i]["timestamp"].slice(0, -6));
                  list += monthshortNames[d.getMonth()]+' '+d.getDate();
                  var hours = d.getHours();
                  var minutes = "0" + d.getMinutes();
                  var seconds = "0" + d.getSeconds();
                  list +='<br>'+hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
                }
                list +='</span></span><div class="shipping_activity_info">';
  
                if(typeof tracklist[i]["log_type_text"]!== "undefined"){
                  list +='<p>'+tracklist[i]["log_type_text"]+'</p>';
                }
                list +='</div></li>';
                trackdetail +=list;
              }
              
            }
            trackresponse += `<div><div class="gridrow"><div class="column-xl-6 column-md-6 column-12">
                        <div class="orderTrackingBox">
                            <h4 class="orderTrackingBox__title titlefirst">${titlefirst}</h4>
                            <div class="orderTrackingBox__inner">
                                <div class="orderTrackingBox__dateEstimate">
                                    <span class="orderTrackingBox__estimateDay">${estimateDay}</span>
                                    <span class="orderTrackingBox__estimateDate">${estimateDate}</span>
                                </div>
                                <h2>${value.packageCarrier}</h2>
                                <p class="statussummary"></p>
                                <div class="orderTrackingBox__number">
                                    <span class="orderTrackingBox__trackLogo"><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/USPS.png?v=1606711241"
                                            width="40" alt="${value.packageCarrier}"></span>
                                    <div class="orderTrackingBox__trackNum">
                                        <p>Tracking Number</p>
                                        <p class="tracking_number">${trackingNumber}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column-xl-6 column-md-6 column-12">
                        <div class="orderTrackingBox">
                            <h4 class="orderTrackingBox__title">Status</h4>
                            <div class="orderTrackingBox__inner">
                                <div class="orderTrackingBox__status">
                                    <span class="orderTrackingBox__currenStatus">${currenStatus}</span>
                                    <ul class="orderTrackingBox__statusBar">
                                        <li class="${statusbar1}"><span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/ot_status_icon3.svg?v=1694768778" alt="icon" width="25"></span></li>  
                                          <li class="${statusbar2}"><span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/ot_status_icon1.svg?v=1694768778" alt="icon" width="25"></span></li>
                                            <li class="${statusbar3}"><span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/ot_status_icon2.svg?v=1694768778" alt="icon" width="25"></span></li>
                                            <li class="${statusbar4}"><span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/ot_delivered_icon_652d0b24-2a3f-4b69-ba42-847167bd80b2.svg?v=1694768778" alt="icon" width="25"></span></li>
                                    </ul>
                                    <h4>Shipping Activity</h4>
                                    <ul class="orderTrackingBox__shippingList">
                                      ${trackdetail}  
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div></div></div>`;
          });
          }
          $('.orderTrackingResponse').html(trackresponse);
          if(totaltracking>1){
          $('.multipleshipments_message').removeClass('hide');
          $(".orderTrackingResponse").slick({
           autoplay: false,
           slidesToShow: 1,
           slidesToScroll: 1,
           arrows: false,
           dots: true,
           infinite: false,
         });
        }
        },
        timeout: 5000000, // sets timeout to 5 seconds
      });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-main-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
     var divName = "trpressrelease";
     var newDiv = '<button id="show-more-news">See More News</button>';
     $("." + divName + ":last").after(newDiv);
     $('#MainContent .trpressrelease').hide();
   if($('#MainContent .trpressrelease:first #allNewsLists .news_logo').length < 20){
     $('#MainContent .trpressrelease:first').show();
      $('#MainContent .trpressrelease:eq(1)').show();
   }else{
     $('#MainContent .trpressrelease:first').show();
   }
    
    var allpressrelease = document.querySelectorAll('.trpressrelease');
    $('#show-more-news').on('click', function() {
         $(allpressrelease[$(".trpressrelease:visible").length]).show();
        if($(".trpressrelease:visible").length == allpressrelease.length){
        $('#show-more-news').addClass('d-none');
      
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider-section"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 
$(".grand_slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    infinite: true,
    fade: true,
    responsive: [

    ],
});
$('.grand_slider_prev-btn').click(function () {
  $(".grand_slider").slick('slickPrev');
});
$('.grand_slider_next-btn').click(function () {
  $(".grand_slider").slick('slickNext');
});

 $(".grand_slider_btn").hover(
    function () {
        var divTop = $(this).offset().top + 100;
        var windowBottom = $(window).scrollTop() + $(window).height();
        if (divTop < windowBottom) {
            $(this).removeClass("tooltip_top");
        }
    },
    function () {
        $(this).addClass("tooltip_top");
    }
); 

   
});
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productGridSection"] && !Shopify.designMode) return;
  try {
    
(function($){
 $(document).ready(function () {
   $(".pdc--slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: false,
    responsive: [
        { breakpoint: 575, lazyLoad: 'progressive', settings: "unslick", },
    ],
});

       });
})(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productSlider"] && !Shopify.designMode) return;
  try {
    
 (function($){
  $(document).ready(function(){
  
  $(".customerFavourite").slick({
             slidesToShow: slidesToShow,
             slidesToScroll: scrollDesktop,
              arrows: arrows,
              adaptiveHeight: !1,
              dots: dots,
              fade: false,
              infinite: false,
              prevArrow: $(".favPrev__btn"),
              nextArrow: $(".favNext__btn"),
              responsive: [{
                  breakpoint: 990,
                  settings: { slidesToShow: slidesToShowtab }
              }, {
                  breakpoint: 751,
                  settings: { slidesToShow: slidesToShowmob ,slidesToScroll: scrollMobile}
              },]
          });
     $(".threeGrid_slider").slick({
  slidesToShow: slidesToShow,
  slidesToScroll: 3,
  arrows: arrows,
  dots: dots,
  adaptiveHeight: true,
  infinite: false,
  responsive: [
  { breakpoint: 990, settings: { slidesToShow: slidesToShowtab, slidesToScroll:2 } },
  { breakpoint: 751, settings: { slidesToShow: slidesToShowmob, slidesToScroll:2} },
  ],
  });
      });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quickviewpopup"] && !Shopify.designMode) return;
  try {
    

  (function($){
  $(document).ready(function(){



  // $('.product-form__variants').on('change', function() {
  // productvariation_switch();
  // });

  });
        })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-bfcm-sale"] && !Shopify.designMode) return;
  try {
    
(function($){
$(document).ready(function () {
 //console.log("loading");
$(".slider--wideFade").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1, }},
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 }}
    ]
});
  $(".fancyTwoSlider").slick({
slidesToShow: 2,
slidesToScroll: 2,
arrows: false,
dots: true,
adaptiveHeight: true,
infinite: true,

responsive: [
{ breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1,} },
],
});
});
  })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !Shopify.designMode) return;
  try {
    
(function($){ 
//console.log('review');
$(document).ready(function(){
 const smallUspsQuote = Array.from(document.querySelectorAll('.all-usp__StyleQuote .single-usp__StyleQuote'));
        let showElmIndexQuote = 0;
        //console.log(smallUspsQuote);
        setInterval(() => {
            smallUspsQuote.map((item, index) => {
                if (index === showElmIndexQuote) {
                    item.style.display = 'flex';
                    item.style.height = "initial" ;
                    item.style.width = "initial" ;
                    item.style.opacity = "1" ;

                } else {
                    // item.style.display = 'none';
                    item.style.height = "0" ;
                    item.style.width = "0" ;
                    item.style.opacity = "0" ;
                }
            })
            showElmIndexQuote === smallUspsQuote.length - 1 ? showElmIndexQuote = 0 : showElmIndexQuote++;
        }, 2500)

        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-kit-faq"] && !Shopify.designMode) return;
  try {
    
  
  $(document).ready(function () {
      $(".faq-question").click(function () {
          let answer = $(this).next(".faq-answer");
          let icon = $(this).find(".faq-expand");

          // Close other answers
          $(".faq-answer").not(answer).slideUp();
          $(".faq-question svg").not(icon).removeClass("rotate");

          answer.slideToggle();
          icon.toggleClass("rotate");
      });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-free-right-slider"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
  //console.log('numSlide');
  var pro_length= $('.pro_count').val();
// var numSlides = $('.onhalfSliderRight  .slick-slide').length;
//   console.log(pro_length)
if (pro_length <= 2) {
   $('.onhalfSliderRight').addClass('slidesTranslate-sm');
} else {
    $('.onhalfSliderRight').addClass('slidesTranslate-lg');
}
$('.onhalfSliderRight').slick({
    slidesToShow: 1.5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow: $(".onhalfSliderRight__btn.onhalfSliderRight__btnLeft"),
    nextArrow: $(".onhalfSliderRight__btn.onhalfSliderRight__btnRight"),
});  

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product"] && !Shopify.designMode) return;
  try {
    
        (function($){

        // Get the first element with the class name 'glazedDonut_slide_z'
    // const trackedSection = document.querySelector('.glazedDonut_slide_z');

    // let startTime;
    // let endTime;
    // let totalTimeSpent = 0;

    // function startTracking() {
    //     startTime = new Date();
    // }

    // function stopTracking() {
    //     endTime = new Date();
    //     const timeSpent = endTime - startTime;
    //     totalTimeSpent += timeSpent;
    //     console.log("Time spent in this session: " + (timeSpent / 1000) + " seconds");
    // }

    // function sendTimeSpent() {
    //     console.log("Total time spent: " + (totalTimeSpent / 1000) + " seconds");
    // }

    // if (trackedSection) {
    //     trackedSection.addEventListener('mouseenter', startTracking);
    //     trackedSection.addEventListener('mouseleave', stopTracking);
    //     window.addEventListener('beforeunload', sendTimeSpent);
    // } else {
    //     console.error("Element with class 'glazedDonut_slide_z' not found.");
    // }

          // Get the section element
  // const section = document.querySelector('.glazedDonut_slide_z');

  // // Start tracking time when the user enters the section
  // section.addEventListener('mouseenter', function() {
  //   // Get the start time
  //   const startTime = Date.now();

  //   // Start a timer
  //   const timer = setInterval(function() {
  //     // Get the current time
  //     const currentTime = Date.now();

  //     // Calculate the time spent in the section
  //     const timeSpent = currentTime - startTime;

  //     console.log(timeSpent);
  //     // Update the display
  //     //document.querySelector('.time-spent').innerHTML = timeSpent;
  //   }, 1000);

  //   // Stop the timer when the user leaves the section
  //   section.addEventListener('mouseleave', function() {
  //     clearInterval(timer);
  //   });
  // });


        $(document).ready(function(){
            //console.log("running");
          $(window).on('scroll', function () {
            const customHeight = 750; // Custom height in pixels
            if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top + customHeight ) {
              $(".sticky-wrap").addClass('sticky-show')
              //$(".head-order-btn").addClass('sticky-hide-head')
            } else {
              $(".sticky-wrap").removeClass('sticky-show')
             // $(".head-order-btn").removeClass('sticky-hide-head')
            }
        });

          if($(window).width() >= 750){
              // Initialize the slick slider for auto-sliding
              // $('.productSliderMain').slick({
              //     slidesToShow: 1,
              //     slidesToScroll: 1,
              //     autoplay: true,
              //     autoplaySpeed: 2000, // Set the speed of auto-sliding in milliseconds
              //     arrows: false, // Hide navigation arrows
              //     dots: false // Hide navigation dots
              // });

          }

          if($(window).width() <= 750){
          // custom hide productctabar
             $(document).ready(function() {
              var $grabGlowDiv = $('.grab-glow');
              var $stickyButton = $('.product-ctaBar');
              function checkIfInView() {
                var windowTop = $(window).scrollTop();
                var windowBottom = windowTop + $(window).height();
                var divTop = $grabGlowDiv.offset().top;
                var divBottom = divTop + $grabGlowDiv.outerHeight();
                if (divBottom >= windowTop && divTop <= windowBottom) {
                  $stickyButton.removeClass('sticky-show');
                } else {
                  // Remove the 'sticky' class when the div is out of the viewport
                  //$stickyButton.addClass('sticky-show');
                }
              }
              $(window).on('scroll', checkIfInView);
              checkIfInView();
            });
            }

        });
              })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["singleImageText"] && !Shopify.designMode) return;
  try {
    
      (function($) {
  $(document).on("click",".addToCart", function(){
    $('.hideformsubmit').trigger('click');
  });

  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferFaq"] && !Shopify.designMode) return;
  try {
    
(function($){
 $(document).ready(function () {
   
// accordian
$(document).on("click", ".accordian_cm .accordian_toggle, .faqAccordian .faqAccordian__toggle", (function () {
        $(this).parent().siblings().removeClass("active"),
        $(this).parent().siblings().find(".accordian_cntnt,.faqAccordian__cntnt").slideUp(),
        $(this).parent().toggleClass("active"),
        $(this).next(".accordian_cntnt, .faqAccordian__cntnt").slideToggle(200)

            // if ($(window).width() < 990) {
            //     setTimeout(() => {
            //     $('body, html').animate({ scrollTop: $(this).parents('.accordian').offset().top - 98 }, 600)
            //     }, 550)
            // }     
})
              
);  
    });
})(jQuery);  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferGrid"] && !Shopify.designMode) return;
  try {
    
  (function($){ 
$(document).ready(function(){
discoverSliderMob(".discover_Slider", false, true, 989);
    function discoverSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 1,
            swipeToSlide: true,
           // autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 750,
                settings: { slidesToShow: 2, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferImgAnimate"] && !Shopify.designMode) return;
  try {
    
  //console.log('img');
  (function($) {
    $(document).ready(function(){
    function run_animate() {
      var animation_items = $(".animate");
        
      var ml1 = 0;
      setInterval(function() {
        if (ml1 <= 0 - $(".animate1 .animate-wrapper").width() / 2 - 16) {
          ml1 = 0;
        }

        $(".animate1 .animate-wrapper").css("margin-left", ml1);
        ml1 -= 0.5;
      }, 20);
        
      var ml2 = 0;
      setInterval(function() {
        if (ml2 <= 0 - $(".animate2 .animate-wrapper").width() / 2 - 16) {
          ml2 = 0;
        }

        $(".animate2 .animate-wrapper").css("margin-left", ml2);
        ml2 -= 0.5;
      }, 20);
        
      var ml3 = 0;
      setInterval(function() {
        if (ml3 <= 0 - $(".animate3 .animate-wrapper").width() / 2) {
          ml3 = 0;
        }

        $(".animate3 .animate-wrapper").css("margin-left", ml3);
        ml3 -= 1;
      }, 20);
    }
    
    $(window).on("load", function() {
      run_animate();
    });  
  });
  })(jQuery);     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferPackage"] && !Shopify.designMode) return;
  try {
    
  (function($){ 
$(document).ready(function(){
  //console.log('package');
  $.ajax({ type: 'POST',  dataType: 'json',  url: '/cart/clear.js'  }); 
  
 packageSliderMob(".package__carousel", false, true, 989);
    function packageSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 1,
            swipeToSlide: true,
           // autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 575,
                settings: { slidesToShow: 2, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }

   $(document).on('click','.bundle_btn',function(e){
    //alert($(this).attr('data-variation-id'));
    var variationid = $(this).attr('data-variation-id');  
     //alert(variationid);
    var quantity = $(this).attr('data-qty'); 
    if(variationid=="39774735106083" && quantity==3){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {items: [{id: variationid,quantity: quantity},{id:32894947917859,quantity:1}]},
          success: function(){ window.location.href = "https://www.trulybeauty.com/checkout";},
          error: function(){alert('Unable to add product to cart.')},
        });
      }else{
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',      
          data: {items: [{id: variationid,quantity: quantity}]},
          success: function(){ window.location.href = "https://www.trulybeauty.com/checkout";},
          error: function(){alert('Unable to add product to cart.')},
        });
      } 
    
   });  

  

    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialoffer-guaranteeSec"] && !Shopify.designMode) return;
  try {
    
  (function($){ 
$(document).ready(function(){
 garunteeSliderMob(".garuntee_carouselSlider", false, false, 1100);
    function garunteeSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 1,
            swipeToSlide: true,
            autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 575,
                settings: { slidesToShow: 2, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialoffer-logo"] && !Shopify.designMode) return;
  try {
    
(function($){
 $(document).ready(function () {
logosecSliderMob(".logosec__slider", true, false, 989);
    function logosecSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 2,
            swipeToSlide: true,
            autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 480,
                settings: { slidesToShow: 3, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }

         });
  
 
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-with-products"] && !Shopify.designMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
     $(".pdc--slider").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      mobileFirst: true,
      infinite: false,
      responsive: [
          { breakpoint: 575, lazyLoad: 'progressive', settings: "unslick", },
      ],
  });

         });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stickywraplanding"] && !Shopify.designMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
      $(".sticky-wrap").addClass('sticky-show')
      //$(".head-order-btn").addClass('sticky-hide-head')
    } else {
      $(".sticky-wrap").removeClass('sticky-show')
     // $(".head-order-btn").removeClass('sticky-hide-head')
    }
});
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-sliderLeft"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 //console.log('sliderLefht');                           
$('.onhalfSliderLeft').slick({
    slidesToShow: 2.5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    rtl: false,
    prevArrow: $(".onhalfSliderLeft__btn.onhalfSliderLeft__btnLeft"),
    nextArrow: $(".onhalfSliderLeft__btn.onhalfSliderLeft__btnRight"),

    responsive: [{
        breakpoint: 990,
        settings: {
            slidesToShow: 1.5,
        }
    }]
      });
});
 })(jQuery);     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-challenge-banner"] && !Shopify.designMode) return;
  try {
    

  
(function($){ 
  //console.log('333333333ewew');
    function run_animate() {
         var ml3 = 0;
        setInterval(function() {
            if (ml3 <= 0 - $(".barbie__animate .barbie__animateWrap").width() / 2) {
            ml3 = 0;
            }
        $(".barbie__animate .barbie__animateWrap").css("margin-left", ml3);
            ml3 -= 1;
        }, 10);
        }
      run_animate();    
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-video-text"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
             $(".mobileVideoSlider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            swipeToSlide: true,
            infinite: true,
            centerMode: true,
            centerPadding: "80px",
            mobileFirst: true,
            responsive: [
                { breakpoint: 750, lazyLoad: 'progressive', settings: "unslick", },
                { breakpoint: 749, settings: { slidesToShow: 1, slidesToScroll: 1, useTransform: false} },
            ],
        });
  
       $(".boxVideo__btn").click(function () {
          var video = $(this).parents('.boxVideo').find(".boxVideo__video").get(0);
      
          video.addEventListener('ended', myHandler, false);
          
          $(this).toggleClass("active");
          if (video.paused === true) {
              video.play();
          } else {
              video.pause();
          }
      
          function myHandler(e) {
              $(this).parents(".famousTiktok__box").find(".boxVideo__btn").removeClass("active");        
          }
      });


        $('.mobileVideoSlider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('video').each(function () {
                this.pause(); // Stop playing
            });
        });

        });
      })(jQuery);     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-beauty-reviews"]) return;
  try {
    
  

  
  (function($) {
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";
    $("form#sproductreviews").submit(function(){
          srequired = ["productId","reviewRating","reviewTitle","author","productName"];
          required = ["reviewMessage"];
          email = $("#email");
          for (i=0;i<required.length;i++) {
            var textarea = $('#'+required[i]);
            if ((textarea.val() == "") || (textarea.val() == emptyerror)) {
              textarea.addClass("needsfilled");
              textarea.val(emptyerror);
            } else {
              textarea.removeClass("needsfilled");
            }
          }
          for (i=0;i<srequired.length;i++) {
            var selectinput = $('#'+srequired[i]);
            if (selectinput.val() == "" || selectinput.val() == emptyerror) {
              selectinput.addClass("needsfilled");
              selectinput.val(emptyerror);
            } else {
              selectinput.removeClass("needsfilled");
            }
          }
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}

          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if ($("#reviewMessage").hasClass("needsfilled")) {
            return false;
          } else {

            var $form = $('#sproductreviews');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#reviewsubmit').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#reviewsubmit').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/trulystampedreviews/write_review.php",
              type: 'POST',
              data: formData,
              dataType: 'Json',
              async: false,
              success: function (response) {
                $form.find('#reviewsubmit').prop('disabled', false);
                    if (response.errors && Object.keys(response.errors).length > 0) {
                      let errorList = $('<ul>');
                      for (const [field, messages] of Object.entries(response.errors)) {
                        errorList.append(`<li>${messages}</li>`);
                      }
                      $('.formresponse').css('color',"#ff0000").html(errorList).removeClass('d-none');
                    }else{
                      $('.formresponse').css('color',"#458c5d").html(response.success.review).removeClass('d-none');
                      $('#sproductreviews')[0].reset();
                      window.setTimeout(function(){ $('.formresponse').addClass('d-none');}, 5000); 
                    }
              },
              error: function(){
                $('.formresponse').css('color',"#ff0000").html('Error submitting review please try again later.').removeClass('d-none');
              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });

        $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});
    
    const stars = document.querySelectorAll('.starrating svg');

        stars.forEach((star, index) => {
            star.addEventListener('click', () => {
                stars.forEach((s, i) => {
                 
                    if (i <= index) {
                        s.classList.add('active');
                      $('#reviewRating').val(i+1);
                    } else {
                        s.classList.remove('active');
                    }
                });
            });
        });
function getHeight() {

            var height = $('#HeaderContent').outerHeight();
            $(':root').css('--header-height', height + 'px');
        }
  function initializePagination(totalPages,currentPage) {
      $('#pagination-container').pagination({
      dataSource: function(done) {
        done(Array.from({ length: totalPages }, (_, i) => i + 1));
      },
      pageSize: 1,
      totalNumber: totalPages,
      pageNumber: currentPage,
      prevText:'Prev',
      nextText:'Next',
      callback: function (data, pagination) {
        if (pagination.pageNumber !== currentPage) {
          currentPage = pagination.pageNumber
          var productid = $('input[name="productid"]').val();
              var ratingvalue = $('input[name="ratingvalue"]').val();
            var sortby = $('.sortBy_list li.active').attr('data-value');
            allreviews(currentPage,productid,ratingvalue,sortby,true);
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      }
    });    
  }
  getHeight();
    
        $(document).ready(function () {
            $('.filterBy_toggle').on('click', function () {
                let parent = $(this).parent();
                parent.siblings().removeClass("active").children(".searchFilter_data").slideUp(100);
                parent.toggleClass("active");
                $(this).next(".searchFilter_data").slideToggle(100);
            })

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.filterBy_toggle, .searchFilter_data').length) {
                    $('.filterBy_toggle').parent().removeClass("active");
                    $('.searchFilter_data').slideUp(100);
                }
            });
          $(document).on('change','.byrating',function(e){
            var byrating = $(this).val();
            $('input[name="ratingvalue"]').val(byrating);
            var productid = $('input[name="productid"]').val();
            var sortby = $('.sortBy_list li.active').attr('data-value');
            allreviews(1,productid,byrating,sortby,true);
            $('.searchFilter_data.rates_1').hide();
            var ratingcr = '';
            for(i = 1; i<=5; i++){
              if(i <= byrating){
                ratingcr+= "<span></span>";
              }else{
              ratingcr+= `<span class="border-stoke"></span>`;  
              }
            }
            var srfilterlist = `<ul><li>
                    <div class="starrating_r">
                        <a href="#">
                            <div class="star-list">
                               ${ratingcr}
                            </div>
                            <span>${byrating} STARS</span>
                            <span class="removeFilter clearminrating"><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/menu-close.svg?v=1744184490" alt="remove"></span>
                        </a>
                    </div>
                </li></ul>`; //<li><a href="javascript:void(0);" class="clearminrating">Clear All</a></li>
            $(".selectedFilter_rating").html(srfilterlist);
          });
          $(document).on('click','.clearminrating', function(){
            $('.selectedFilter_rating').html('');
              var productid = $('input[name="productid"]').val();
            var sortby = $('.sortBy_list li.active').attr('data-value');
            allreviews(1,productid,'',sortby,true);
          })
          $(document).on('click','#suggestionsList li', function(e){
            var productId = $(this).attr('data-productid');
            $('#suggestionsList').hide();
            $('input[name="productid"]').val(productId);
             var ratingvalue = $('input[name="ratingvalue"]').val();
            var sortby = $('.sortBy_list li.active').attr('data-value');
            allreviews(1,productId,ratingvalue,sortby,true);
            $('input[name="rproductsearch"]').val('');
            $('.searchFilter_data').hide();
            var spfilterlist = `<li>
              <a class="switchproduct" data-productid="${productId}" href="javascript:void(0)">
                <span>${$(this).text()}</span>
              </a>
              <span class="removeFilter clearproduct">
                <img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/menu-close.svg?v=1744184490" alt="remove">
                </span>
            </li>`;
            $('.selectedFilter_list ul').prepend(spfilterlist);
            $('.selectedFilter_list').removeClass('d-none');
          });

           $(document).on('click','.switchproduct', function(e){
            var productId = $(this).attr('data-productid');
            $('#suggestionsList').hide();
            $('input[name="productid"]').val(productId);
             var ratingvalue = $('input[name="ratingvalue"]').val();
            var sortby = $('.sortBy_list li.active').attr('data-value');
            allreviews(1,productId,ratingvalue,sortby,true);
            $('input[name="rproductsearch"]').val('');
            $('.searchFilter_data').hide();
          });
          
          $(document).on('click','.clearproduct', function(){
            var clearproductid = $(this).attr('data-productid');
            var currentsearchproducts = document.querySelectorAll(".selectedFilter_list ul li");
            var csproductslength = currentsearchproducts.length;
            if(clearproductid == '' || csproductslength == 2){
              $('.selectedFilter_list').html('');
               var ratingvalue = $('input[name="ratingvalue"]').val();
               var sortby = $('.sortBy_list li.active').attr('data-value');
               allreviews(1,'',ratingvalue,sortby,true);
            }else{
              var stayproductid = $(this).parent().prev('li').find('a').attr('data-productid');
              if (typeof(stayproductid) == "undefined"){
                var stayproductid = $(this).parent().next('li').find('a').attr('data-productid');
              }
              $(this).parent().remove();
               allreviews(1,stayproductid,ratingvalue,sortby,true);
            }
            
          })
          $(document).on('keyup','input[name="rproductsearch"]',function(e){
            $('#suggestionsList').html('');
            var querystring = $(this).val();
            if(querystring.length >=2){
            $('.search_input-h .loader-wrapper_inner').removeClass('d-none');
                fetch(
                `/search/suggest.json?q=${querystring}&resources[type]=product&resources[limit]=10&resources[limit_scope]=each`
              )
                .then((response) => {
                  if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                  }
          
                  return response.text();
                })
                .then((text) => {
                  var obj = jQuery.parseJSON(text);
                  var queries = obj.resources.results.products;
                  var productlist = '';
                  if (queries.length > 0) {
                    $.each(queries, function (i, data) {
                      if (
                        data.title.indexOf("Exclusive") === -1 &&
                        data.title.indexOf("Fee") === -1 &&
                        data.title.indexOf("Special") === -1 &&
                        data.handle.endsWith("-byob") === false &&
                        data.tags.indexOf("hide_addtocart") === -1 &&
                        data.tags.indexOf("hide_product") === -1
                      ) {
                        productlist += `<li data-productid="${data.id}"><img src="${data.image}">${data.title.toString()}</li>`;
                      }
                    });
                    $('.search_input-h .loader-wrapper_inner').addClass('d-none');
                    $('#suggestionsList').html(productlist);
                    $('#suggestionsList').show();
                  }else{
                     $('.search_input-h .loader-wrapper_inner').addClass('d-none');
                    $('#suggestionsList').hide();
                  }
                })
                .catch((error) => {
                  this.close();
                  throw error;
                });
            }else{
              $('#suggestionsList').hide();
            }
            
          });
          $(document).on('click','#wrsuggestionsList li', function(e){
            var productId = $(this).attr('data-productid');
             var productli = $(this).text();
            $('#wrsuggestionsList').hide();
            $('input[name="productName"]').val(productli);
            $('input[name="productId"]').val(productId);
          });
          $(document).on('keyup','input[name="productName"]',function(e){
            $('#wrsuggestionsList').html('');
            var querystring = $(this).val();
            if(querystring.length >=2){
              $('.form-container-1.v-text-padding .loader-wrapper_inner').removeClass('d-none');
                fetch(
                `/search/suggest.json?q=${querystring}&resources[type]=product&resources[limit]=10&resources[limit_scope]=each`
              )
                .then((response) => {
                  if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                  }
          
                  return response.text();
                })
                .then((text) => {
                  var obj = jQuery.parseJSON(text);
                  var queries = obj.resources.results.products;
                  var productlist = '';
                  if (queries.length > 0) {
                    $.each(queries, function (i, data) {
                      if (
                        data.title.indexOf("Exclusive") === -1 &&
                        data.title.indexOf("Fee") === -1 &&
                        data.title.indexOf("Special") === -1 &&
                        data.handle.endsWith("-byob") === false &&
                        data.tags.indexOf("hide_addtocart") === -1 &&
                        data.tags.indexOf("hide_product") === -1
                      ) {
                        productlist += `<li data-productid="${data.id}"><img src="${data.image}"/>${data.title.toString()}</li>`;
                      }
                    });
                    $('.form-container-1.v-text-padding .loader-wrapper_inner').addClass('d-none');
                    $('#wrsuggestionsList').html(productlist);
                    $('#wrsuggestionsList').show();
                  }else{
                    $('.form-container-1.v-text-padding .loader-wrapper_inner').addClass('d-none');
                    $('#wrsuggestionsList').hide();
                  }
                })
                .catch((error) => {
                  this.close();
                  throw error;
                });
            }else{
              $('#wrsuggestionsList').hide();
            }
            
          });
        }); // Search result filter

        $(document).ready(function () {
            $(".sortByToggle").click(function () {
                $(".sortBy_list").toggle();
                $(this).toggleClass("open");
            });
            $(".sortBy_list li").click(function () {
                var selected_value = $(this).html();
                var current_value = $(".sortByToggle span").html();
                $(".sortByToggle span").html(selected_value);
                $(".sortBy_list li").removeClass("active");
                $(this).addClass("active");
                $(".sortBy_list").hide();
                $(".sortByToggle").removeClass("open");
              var productid = $('input[name="productid"]').val();
              var ratingvalue = $('input[name="ratingvalue"]').val();
            var sortby = $('.sortBy_list li.active').attr('data-value');
            allreviews(1,productid,ratingvalue,sortby,true);
            });
        }); // Short by filter
    if ($(window).width() <= 989) {
            $('.searchResult_filterBy_title').on('click', function () {
                $(this).parent().addClass('open_filler')
                $('html').addClass('showfillter')
                $(".sortBy_list").hide();
            });

            $("#title_heading1").click(function () {
                $('.searchResult_outer').removeClass('open_filler')
                $('html').removeClass('showfillter')
            });

            $('.cross_right_l').click(function () {
                $('.searchResult_outer').removeClass('open_filler')
                $('html').removeClass('showfillter')
            })
        }
    
  function allreviews(page,productId,minRating,sortReviews,secondrun) {
          if(secondrun == true){
            $('.allreviews').css('position','relative').html('<div class="loader-wrapper-allreview"><div class="loader_review"></div></div>');  
          }
          $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/trulystampedreviews/index.php",
              type: 'POST',
              dataType: 'json',
              data: {
              ajaxaction: "stampedreviews",
              page:page,  
              productId: productId,
              minRating: minRating,
              sortReviews: sortReviews,
            },
            async: true,
              success: function(reviewresponse) {
                  //console.log(reviewresponse);
                totalPages = reviewresponse.total/30;
                if(reviewresponse.total >= 30 ){
                  $('.b-pagination-outer').removeClass('d-none');
                }else{
                  $('.b-pagination-outer').addClass('d-none');
                }
                initializePagination(totalPages,reviewresponse.page);
                  $('.rw-total').html(reviewresponse.total);
                  $('.rw-rating').html(reviewresponse.rating);
                  var allreviews = ''
                  reviewresponse.data.forEach(function(review, index) {
                   // alert(review.reviewTitle);
                    var rverifed = '';
                    if(review.source == 5 && review.reviewVerifiedType == 2){
                      rverifed = '<img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/shopify_verified-by-shop-gray.svg?v=1748509413" alt="Shop Verified">';
                    }else if(review.source == 1 && review.reviewVerifiedType == 2){
                      rverifed = '<img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/Verified-buyers.svg?v=1748509601" alt="Verified">Verified Buyer';
                    }
                    var starlist = '';
                    for(i = 1; i<=5; i++){
                      if(i <= review.reviewRating){
                        starlist+= "<span></span>";
                      }else{
                      starlist+= `<span class="border-stoke"></span>`;  
                      }
                    }
                    var optionlist = '';
                    if (typeof review.reviewOptionsList !== 'undefined' && review.reviewOptionsList.length > 0) {
                      optionlist = '<p><label>'+review.reviewOptionsList[0].message+':</label> '+review.reviewOptionsList[0].value+'</p>'
                    }
                    var productvariant = '';
                    if(typeof(review.productVariantName) !== "undefined" &&  review.productVariantName != ''){
                      productvariant = ' - '+review.productVariantName;
                    }
                    var reviewimage = '';
                    if(review.productImageUrl !=''){
                      reviewimage = `<img src="${review.productImageUrl}" alt="${review.productName}">`;
                    }
                    if(review.reviewTitle!=''){
                      reviewtitle = `<h2>${review.reviewTitle.replace(/<\/?[^>]+(>|$)/g, "")}</h2>`;
                    }else{
                      reviewtitle = '';
                    }
                   allreviews += `<div class="reviews_individuals">
                    <div class="reviews_wrapper_ec">
                        <div class="review_img">${reviewimage}</div>
                        <div class="review_contents-l">
                            <div class="star-list">${starlist}</div>
                            <p>${review.author}<span>${rverifed}</span>
                            </p>
                        </div>
                        <div class="review_dates">
                            <p>${review.reviewDate}</p>
                        </div>

                    </div>
                    <div class="reviews_m_data">
                        ${reviewtitle}
                        <p>"${review.reviewMessage}" </p>
                    </div>

                    <div class="reviews_text">
                        <div class="reviews_left">
                            <p>${review.productName}${productvariant}</p>
                            ${optionlist}
                        </div>

                        <div class="reviews_right">
                            <p>Was this review helpful?</p>
                            <span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/thumsup.png?v=1632733611" width="14" height="14" alt="like">${review.reviewVotesUp}</span>
                            <span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/thumdown.png?v=1632733611" width="14" height="14" alt="dislike">${review.reviewVotesDown}</span>
                        </div>
                    </div>
                </div>`;
                  });
                $('.allreviews').html(allreviews);  
                // let oldresult = document.querySelectorAll('.allreviews');
                // alert(oldresult.length);
                // if($('#allreviews').html() === ""){
                //   $('.allreviews').html(allreviews);  
                // }else{
                //   document.querySelectorAll('.allreviews').forEach(el => {
                //     if(el.dataset.productid != ''){
                //         if(el.dataset.productid == productId){
                //           $('.allreviews').html(allreviews).attr('data-productid',productId);
                //         }else{
                //           $('.allreviews').after('<div class="allreviews" data-productid="'+productId+'">'+allreviews+'</div>');
                //         }
                //     }
                    
                //     });
                // }
                
                
                $('.loader-wrapper').fadeOut('fast');
              },
              timeout: 5000000, // sets timeout to 5 seconds

          });
      }
    var productid = $('input[name="productid"]').val();
              var ratingvalue = $('input[name="ratingvalue"]').val();
            var sortby = $('.sortBy_list li.active').attr('data-value');
            allreviews(1,productid,ratingvalue,sortby,false);
    
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-giveaways-form"] && !Shopify.designMode) return;
  try {
    
      $(document).ready(function() {
          // Initialize intl-tel-input
          const phoneInputField = document.querySelector("#phone_number");
          const phoneInput = window.intlTelInput(phoneInputField, {
              initialCountry: "us",
              strictMode: true,
              utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
          });

  var input = document.querySelectorAll('#signup_birthday')[0];

  var dateInputMask = function dateInputMask(elm) {
    elm.addEventListener('keypress', function(e) {
      if(e.keyCode < 47 || e.keyCode > 57) {
        e.preventDefault();
      }
      var len = elm.value.length;
      if(len !== 1 || len !== 3) {
        if(e.keyCode == 47) {
          e.preventDefault();
        }
      }

      if(len === 2) {
       var month = elm.value.substring(0, 2);
          if (parseInt(month, 10) > 12) {
              month = '12'; // Max month is 12
          }
      elm.value = month;
      elm.value += '-';
      }

      if(len === 5) {
        var day = elm.value.substring(3, 5);
          if (parseInt(day, 10) > 31) {
              day = elm.value.substring(0, 3)+'31'; // Max day is 31
          }else{
            day = elm.value.substring(0, 3)+day;
          }
        elm.value = day;
        elm.value += '-';
      }
    });
  };

  dateInputMask(input);

              // form validations and form data
              const emptyError = "Please fill out this field.";
              const $submitButton = $("#submit_detail"); // Store the submit button
              const formAction = $("#register_form").attr("action");
              //console.log(formAction);
              $("form#register_form").on('submit', function(e) {
                  e.preventDefault(); // Prevent default form submission
                  let isValid = true;
                  let firstInvalidField = null;
                  // List of required fields
                  const required = [
                      'first_name', 'last_name', 'email', 'phone_number',
                      'signup_birthday , smscheckbox'
                  ];

                  // Clear previous error messages and styling
                  $("input").removeClass("needsfilled_giveaway error");
                  $(".error-message").text('');

                  // Validate required fields
                  for (const field of required) {
                      const input = $('#' + field);
                      if (input.val() === "" || input.val() === emptyError) {
                          input.addClass("needsfilled_giveaway error");
                          isValid = false;
                          if (!firstInvalidField) firstInvalidField = input;
                      } else {
                          input.removeClass("needsfilled_giveaway");
                      }
                  }

                  // Additional validation for email address
                  const email = $("#company_email");
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailRegex.test(email.val()) || email.val() === "" && email.hasClass('needsfilled_giveaway')) {
                      email.addClass("needsfilled_giveaway error");
                      email.val("Enter valid email address"); // Set the placeholder text
                      isValid = false;
                      if (!firstInvalidField) firstInvalidField = email;
                  }

                  // Additional validation for phone number
                  let PhoneNumber = $('#phone_number');
                  if (!phoneInput.isValidNumber() || PhoneNumber.val() === "" && PhoneNumber.hasClass('needsfilled_giveaway')) {
                      $('#phone_number').addClass("needsfilled_giveaway error");
                      PhoneNumber.val("Enter valid phone number"); // Set the placeholder text
                      isValid = false;
                      if (!firstInvalidField) firstInvalidField = $('#phone_number');
                  }

                  // checkbox validation
                   const smsCheckbox = $("#smscheckbox");
                    if (!smsCheckbox.is(":checked")) {
                        $("#smscheckbox").addClass('redcheckbox')
                        smsCheckbox.focus();
                        isValid = false;
                        return false; // Prevent form submission
                    }else{
                      $("#smscheckbox").removeClass('redcheckbox')
                    }
                  // If all fields are valid, change button text to "Submitting..." and disable it
                  if (isValid) {
                      $submitButton.text("Submitting...").prop("disabled", true);

                      let formDataArray = $(this).serializeArray();

                      // Remove the company_postal_code field and any blank fields from formDataArray
                      formDataArray = formDataArray.filter(function(field) {
                          return field.value.trim() !== "";
                      });

                      // Add the formatted phone number to formDataArray
                      const formattedPhoneNumber = phoneInput.getNumber();
                      formDataArray.push({
                          name: 'phone_number',
                          value: formattedPhoneNumber
                      });

                      // Convert formDataArray back to object
                      const formData = {};
                      formDataArray.forEach(function(item) {
                          formData[item.name] = item.value;
                      });
                      //console.log(formData);
                      $.ajax({
                          type: 'POST',
                          url: formAction,
                          data: formData,
                          success: function(response) {
                              if (typeof response === "string") {
                                  response = JSON.parse(response);
                              }
                              //console.log("Raw response:", response);
                              if (response.status === 'success') {
                               $('.success-message').html(`<span class="response-style"> ${response.message} </span>` )
                               $('#first_name').val("");
                               $('#last_name').val("");
                               $('#company_email').val("");
                               $('#phone_number').val("");
                               $('#signup_birthday').val(""); 
                              }else{
                               $('.success-message').html(`<span class="response-style redresponse"> ${response.message} </span>`) 
                              }
                              setTimeout(function () {
                                  $('.response-style, .redresponse').fadeOut(100, function () {
                                      $(this).remove();
                                  });
                              }, 3000);
                              $submitButton.text("Submit").prop("disabled", false);
                          },
                          error: function(xhr, status, error) {
                              console.error('An error occurred. Please try again.', error);
                              $('.error-message').html('<span class="response-style"> An error occurred. Please try again.</span>');
                              $submitButton.text("Submit").prop("disabled", false); // Re-enable the button on error
                          }
                      });
                  } else {
                      if (firstInvalidField) {
                          $('html, body').animate({
                              scrollTop: firstInvalidField.offset().top
                          }, 500, function() {
                              firstInvalidField.focus();
                          });
                      }
                      //console.log('Please fill out all required fields.');
                      $submitButton.text("Submit").prop("disabled", false); // Re-enable the button on validation error
                  }
              });
              $(":input").focus(function() {
                  if ($(this).hasClass("needsfilled_giveaway")) {
                      $(this).val("");
                      $(this).removeClass("needsfilled_giveaway error");
                  }
              });

      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-sms-subscribe"] && !Shopify.designMode) return;
  try {
    
  (function($){
       $(document).ready(function(){  
           $("#ps__phone-subscribe").keypress(function (e) {
          if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
          }
          var curchr = this.value.length;
          var curval = $(this).val();
          if (curchr == 3 && curval.indexOf("(") <= -1) {
            $(this).val("(" + curval + ")" + "-");
          } else if (curchr == 4 && curval.indexOf("(") > -1) {
            $(this).val(curval + ")-");
          } else if (curchr == 5 && curval.indexOf(")") > -1) {
            $(this).val(curval + "-");
          } else if (curchr == 9) {
            $(this).val(curval + "-");
            $(this).attr('maxlength', '15');
          }
        });
      });
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-subscription-box"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 //console.log('smo');
  $(".subscribe-info .common-btn").click(function() {
        $('html,body').animate({
            scrollTop: $(".choose-subscribe-sec").offset().top},
            'slow');
    });
  
    $(".smoothScroll").on('click', function(event) {

                if (this.hash !== "") {
                    event.preventDefault();
                    // Store hash
                    var hash = this.hash;
                    $('html, body').animate({ scrollTop: $(hash).offset().top}, 800, function(){ window.location.hash = hash;});
                } // End if
                });




        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-subscription-gallery"] && !Shopify.designMode) return;
  try {
    
(function($){ 
$(document).ready(function() {
//console.log('gallery');
$.fn.randomize = function(selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function() {
        $(this).children(selector).sort(function(childA, childB) {
            // * Prevent last slide from being reordered
            if ($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
            }
        }.bind(this)).detach().appendTo(this);
    });

    return this;
};
$('.subscribeGallerySlider').find('.subscribe-gallery').randomize('.gallery-img');

$(".subscribeGallerySlider").randomize().slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
})
});
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanilla-viplist-form"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    // Initialize intl-tel-input
    const phoneInputField = document.querySelector("#phone_number");
    const phoneInput = window.intlTelInput(phoneInputField, {
        initialCountry: "us",
        strictMode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
    });

    $('#register_form').on('submit', function (e) {
        e.preventDefault(); // Prevent the default form submission
        
        const fname = $('#first_name');
        const email = $('#email');
        const phone = $('#phone_number');
        var actionValue = $("#register_form").attr("action");
        let isValid = true;

        // Validate first name
        if (fname.val().trim() === '') {
            fname.addClass("form_error");
            fname.attr("placeholder", "Enter full name");
            isValid = false;
        } else {
            fname.removeClass("form_error");
        }

        // Validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.val().trim())) {
            email.addClass("form_error");
            email.val("").attr("placeholder", "Enter a valid email address");
            isValid = false;
        } else {
            email.removeClass("form_error");
        }

        // Validate phone
        if (phoneInput.getNumber().trim() === "" || !phoneInput.isValidNumber()) {
            phone.addClass("form_error");
            phone.val("").attr("placeholder", "Enter a valid phone number");
            isValid = false;
        } else {
            phone.removeClass("form_error"); 
        }
        // Validate marting and sms
        if ($('input#marktingsmsemail').is(':checked')) {
            $('input#marktingsmsemail').removeClass("form_error");
        } else {
           $('input#marktingsmsemail').addClass("form_error");
            isValid = false;
        }

        // Submit form if all fields are valid
        if (isValid) {
            const formData = {
                ajaxaction: 'klaviyoformsubmit',
                first_name: fname.val().trim(),
                email: email.val().trim(),
                phone_number: phoneInput.getNumber()
            };
            $.ajax({
            url: actionValue,
            type: 'POST',
            data: formData,
            success: function (response) {
                    if (typeof response === "string") {
                        response = JSON.parse(response);
                    }
                    if (response.status === 'success') {
                        $('#button_response').after(
                            `<p class='response_text'>${response.message}</p>`
                        );
                    } else {
                        $('#button_response').after(
                            `<p class='response_text_red'>${response.message}</p>`
                        );
                    }
                   setTimeout(function () {
                    $('.response_text, .response_text_red').fadeOut(100, function () {
                        $(this).remove();
                    });
                }, 3000);
            },
            error: function (xhr, status, error) {
                console.error('Error:', error);
                $('#button_response').after(
                    `<p class='response_text_red'>Form is not submitted due to ${error}</p>`
                );
        
                // Automatically remove error message after 3 seconds
                setTimeout(function () {
                    $('.response_text_red').fadeOut(100, function () {
                        $(this).remove();
                    });
                }, 3000);
            }
        });
        }
    });  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-product-main"] && !Shopify.designMode) return;
  try {
    
 
(function($){    

   $(document).ready(function() {
     $('.product-form__variants').on('change', function() {
      var selectedValue = $(this).val();
    $('.subscription_product').val(selectedValue);
     $('.subscription_var_price').addClass('var_change');
  });
});
  
  function productvariation_switch(){
     
          var variationID = $('.product-form__variants option:selected').val();
          var productUrl = $('.productDetail input[name="producthandle"]').val();
          var onetimesubscribeoption = $('input[type=radio][name=sellingplan_option]:checked').val();
          jQuery.getJSON(productUrl + '.js', function(product) {
            $.each(product.variants, function(i){
              if( product.variants[i].id == variationID ){
                var price = product.variants[i].price;
            var compare_price = product.variants[i].compare_at_price;
                if(product.variants[i].featured_media!=null){
                  var variantimageID = product.variants[i].featured_media.id;

             
                }
            if(typeof onetimesubscribeoption !== "undefined" && onetimesubscribeoption=='subscription'){ //
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                   $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                   $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                    $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  var sellingplan = $('select[name="selling_plan"]').val();
                  $.each(product.variants[i].selling_plan_allocations, function(j){
                    if(sellingplan==product.variants[i].selling_plan_allocations[j].selling_plan_id){
                      var price = product.variants[i].selling_plan_allocations[j].price;
                      $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                    }
                  });
                }else{
                if(product.variants[i].selling_plan_allocations!=''){
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                  $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                        $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                }
                  $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(price, theme.moneyFormat));

                }
                if(variantimageID){
                  $('.productSliderNav img').each(function(){
                    if ($(this).attr("id") == variantimageID) {
                      $(this).click();
                      $(this).parent().parent().addClass('slick-current');
                    }
                  });
                }
    // console.log("price:",price);
    // document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", price);
    // window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    // window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
              }
            })

          });
        }
$(document).ready(function(){  
productvariation_switch();
$('.product-form__variants').on('change', function() {
productvariation_switch();
});
  
// $(window).on('scroll', function () {
//     if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
//       $(".sticky-wrap").addClass('sticky-show')
//       //$(".head-order-btn").addClass('sticky-hide-head')
//     } else {
//       $(".sticky-wrap").removeClass('sticky-show')
//      // $(".head-order-btn").removeClass('sticky-hide-head')
//     }
// });
  

});
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbc-vanilla-video"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function () {
    var video = $(".PlayVideoBox video");
    var playPauseBtn = $("#videoplayBtn");
    var playIcon = playPauseBtn.find(".playBtn");
    var pauseIcon = playPauseBtn.find(".pausebtn");

    playPauseBtn.on("click", function () {
        if (video.get(0).paused) {
            video.get(0).play();
            playPauseBtn.removeClass("active");
            playIcon.css("opacity", "0");
            pauseIcon.css("opacity", "1");
        } else {
            video.get(0).pause();
            playPauseBtn.addClass("active");
            playIcon.css("opacity", "1");
            pauseIcon.css("opacity", "0");
        }
    });

    // Ensure correct button state on video load
    video.on("play", function () {
        playPauseBtn.removeClass("active");
        playIcon.css("opacity", "0");
        pauseIcon.css("opacity", "1");
    });

    video.on("pause", function () {
        playPauseBtn.addClass("active");
        playIcon.css("opacity", "1");
        pauseIcon.css("opacity", "0");
    });
});

  } catch(e) { console.error(e); }
})();
})();
